export default {
  'pages.accounting.salaryManagement.settlement.proration': 'Prorated base pay',
  'pages.accounting.salaryManagement.settlement.prorationHelp':
    'Base pay only is prorated for {days}/{total} working days: {amount}. Employer insurance remains the normal monthly amount.',
  'pages.accounting.salaryManagement.settlement.compensation': 'Additional compensation',
  'pages.accounting.salaryManagement.settlement.compensationHelp':
    'Compensation of {amount} is included once in this month, in addition to normal cost. No other payroll or actual payment records are created.',
  'pages.accounting.salaryManagement.settlement.monthlyBase': 'Original monthly base pay: {amount}',
  'pages.accounting.salaryManagement.settlement.reviewHelp':
    'Employment dates differ from the approved individual settlement. Review payroll and cost.',
  'pages.interviewList.simple.basic': 'Basic Information',
  'pages.interviewList.simple.gender': 'Gender',
  'pages.interviewList.simple.birthday': 'Date of birth',
  'pages.interviewList.simple.age': 'Age {age}',
  'pages.interviewList.simple.country': 'Nationality',
  'pages.interviewList.simple.region': 'Province / Region',
  'pages.interviewList.simple.visa': 'Residence Information',
  'pages.interviewList.simple.visaExpiry': 'Residence expiry date',
  'pages.interviewList.simple.remainingDays': '{days} days remaining',
  'pages.interviewList.simple.screening': 'Resume Screening',
  'pages.interviewList.simple.screeningResult': 'Screening result',
  'pages.interviewList.simple.screeningRemarks': 'Screening notes',
  'pages.interviewList.simple.first': 'First Interview',
  'pages.interviewList.simple.interviewer': 'Interviewer',
  'pages.interviewList.simple.interviewStatus': 'Interview status',
  'pages.interviewList.simple.skill': 'Experience and skills',
  'pages.interviewList.simple.communication': 'Communication',
  'pages.interviewList.simple.thinking': 'Initiative and thinking',
  'pages.interviewList.simple.personality': 'Personal suitability',
  'pages.interviewList.simple.motivation': 'Motivation',
  'pages.interviewList.simple.japanese': 'Japanese ability',
  'pages.interviewList.simple.scoreGuide': 'Scoring criteria',
  'pages.interviewList.simple.evaluation': 'Interview Evaluation',
  'pages.interviewList.simple.rollback': 'Return to screening (clear first interview)',
  'pages.interviewList.simple.training': 'Training',
  'pages.interviewList.simple.trainingHint':
    'HR registers the start date. Development manages the training period, tests and evaluations.',
  'pages.interviewList.simple.trainingStart': 'Training start date',
  'pages.interviewList.simple.developmentManaged':
    'Development has taken over. Change the start date in the progress calendar.',
  'pages.interviewList.simple.followup': 'Development follow-up (read only)',
  'pages.interviewList.simple.trainingEnd': 'Training end date',
  'pages.interviewList.simple.trainingStatus': 'Training status',
  'pages.interviewList.simple.testDate': 'Test date',
  'pages.interviewList.simple.testResult': 'Test result',
  'pages.interviewList.simple.trainingRemarks': 'Training notes',
  'pages.interviewList.simple.accountStatus': 'Account status',
  'pages.interviewList.simple.active': 'Active',
  'pages.interviewList.simple.inactive': 'Disabled',
  'pages.interviewList.simple.accountNotCreated': 'Not created',
  'pages.interviewList.simple.pendingTrainings': 'HR registrations awaiting scheduling',
  'pages.interviewList.simple.arrangeTraining': 'Schedule',
  'pages.interviewList.simple.waitingAccount': 'Awaiting account creation by HR',
  'pages.interviewList.simple.completePeriod': 'Enter a valid start and end date.',
  'pages.interviewList.simple.status.not_started': 'Not conducted',
  'pages.interviewList.simple.status.completed': 'Completed',
  'pages.interviewList.simple.status.declined': 'Withdrawn',
  'pages.interviewList.simple.status.absent': 'Absent without notice',
  'pages.development.frontendStage': 'Stage 1: Frontend Learning',
  'pages.development.backendStage': 'Stage 2: Backend Learning',
  'pages.development.backendProgressStage': 'Stage 2: Backend Learning (SQL / Java)',
  'pages.development.displayName': 'Display name',
  'pages.development.sourceName': 'Source name (video and data reference)',
  'pages.development.stageFilter': 'Learning stage',
  'pages.development.topicFilter': 'Learning topic',
  'pages.accountManagement.delete.departureRequired':
    'Enter the departure date in Employee Information before disabling contract or regular employees.',
  'pages.accountManagement.restore': 'Restore',
  'pages.accountManagement.restore.confirmTitle': 'Restore this account?',
  'pages.accountManagement.restore.confirmDescription':
    'Re-enable login, retained role permissions and linked information for {accountName}. Departure information will not change. Previously deleted roles must be reassigned separately.',
  'pages.accountManagement.restore.done':
    'Account restored with retained role permissions and linked information. Previously deleted roles require reassignment.',
  'pages.accountManagement.restore.failed': 'Failed to restore the account.',
  'pages.accounting.salaryManagement.historicalMonth': 'Past months are read-only.',
  'pages.accounting.salaryManagement.contractType.management': 'Regular employee - Management',
  'pages.accounting.salaryManagement.cost.fixedHelp':
    'Zero project revenue: management cost is fixed at JPY 100,000. Actual salary and insurance details remain unchanged.',
  'pages.accounting.dashboard.fixedCost.note':
    'Zero-revenue employees use a monthly management cost of JPY 100,000, except management and approved internal employees. Individual proration and compensation are shown separately; totals may differ from salary and insurance details.',
  'pages.accounting.dashboard.warning.payrollDetail':
    'Salary or insurance details need review. Profit can still be calculated for employees using fixed costs.',
  'pages.layouts.userLayout.title': 'We don’t just write code—we’re debugging the future',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.accountName.placeholder': 'Username:',
  'pages.login.accountName.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password:',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  // Employee List Page
  'pages.employeeList.title': 'Employee List',
  'pages.employeeList.employeeNo': 'Employee ID',
  'pages.employeeList.fullNameKanji': 'Employee Name',
  'pages.employeeList.accountName': 'Account Name',
  'pages.employeeList.status': 'Status',
  'pages.employeeList.status.undefined': 'Undefined',
  'pages.employeeList.all': 'All',
  'pages.employeeList.total': 'Total',
  'pages.employeeList.reload': 'Reload',
  'pages.employeeList.terminationType': 'Terminated Personnel',
  'pages.employeeList.terminationType.bpFinishedTitle': '[Contract Ended]',
  'pages.employeeList.terminationType.dropout': 'Training Dropout',
  'pages.employeeList.terminationType.resigned': 'Resigned',
  'pages.employeeList.terminationType.bpFinished': 'BP Finished',
  'pages.employeeList.allActive': 'All (Active)',
  'pages.employeeList.allTerminated': 'All (Terminated)',
  'pages.employeeList.regularConfirmStatus': 'Regular Confirm Status',
  'pages.employeeList.regularConfirmStatus.unconfirmed': 'Unconfirmed',
  'pages.employeeList.regularConfirmStatus.confirmed': 'Confirmed OK',
  'pages.employeeList.regularConfirmStatus.rejected': 'Postponed',
  'pages.employeeList.actionRequired': 'Action Required',
  'pages.employeeList.actionRequired.all': 'Action Required',
  'pages.employeeList.actionRequired.birthdayLastMonth': 'Last Month Birthday',
  'pages.employeeList.actionRequired.birthdayThisMonth': 'This Month Birthday',
  'pages.employeeList.actionRequired.birthdayNextMonth': 'Next Month Birthday',
  'pages.employeeList.actionRequired.visaRenewal90Days': 'Visa Renewal (90 Days)',
  'pages.employeeList.actionRequired.regularInterviewWait': 'Regular Interview Pending',
  'pages.employeeList.actionRequired.regularContractWait': 'Regular Contract Pending',

  // 社員一覧管理 - 筛选标签
  'pages.employeeList.gender': 'Gender',
  'pages.employeeList.birthday': 'Birthday',
  'pages.employeeList.age': 'Age',
  'pages.employeeList.yearsOfService': 'Years of Service',
  'pages.employeeList.visaCardNo': 'Residence Card No.',
  'pages.employeeList.visaType': 'Visa Type',
  'pages.employeeList.visaValidTo': 'Valid Until',
  'pages.employeeList.remainingDays': 'Remaining Days',
  'pages.employeeList.individualNumber': 'Individual No.',
  'pages.employeeList.bankAccount': 'Bank Account',
  'pages.employeeList.phone': 'Phone',
  'pages.employeeList.mailAddress': 'Email',
  'pages.employeeList.address': 'Address',
  'pages.employeeList.remarks': 'Remarks',

  // 社員一覧管理 - 性别
  'pages.employeeList.gender.unset': 'Unset',
  'pages.employeeList.gender.male': 'Male',
  'pages.employeeList.gender.female': 'Female',
  'pages.employeeList.gender.other': 'Other',

  // 社員一覧管理 - 部门
  'pages.employeeList.department.dev1': 'Dev Dept 1',
  'pages.employeeList.department.dev2': 'Dev Dept 2',
  'pages.employeeList.department.accounting': 'Accounting',
  'pages.employeeList.department.hr': 'HR',
  'pages.employeeList.department.sales': 'Sales',
  'pages.employeeList.department.ga': 'General Affairs',
  'pages.employeeList.department.it': 'IT Dept',
  'pages.employeeList.department.bp': 'BP Staff',

  // 社員一覧管理 - 职位
  'pages.employeeList.position.member': 'Member',
  'pages.employeeList.position.chief': 'Chief',
  'pages.employeeList.position.manager': 'Manager',
  'pages.employeeList.position.director': 'Director',

  // 社員一覧管理 - 所属形態
  'pages.employeeList.contractType': 'Affiliation Type',
  'pages.employeeList.contractType.bpActiveTitle': '[In Contract]',
  'pages.employeeList.contractType.trainee': 'Employment-Oriented',
  'pages.employeeList.contractType.internal': 'Internal Trainee',
  'pages.employeeList.contractType.contract': 'Contract Employee',
  'pages.employeeList.contractType.regular': 'Regular Employee',
  'pages.employeeList.contractType.bp': 'BP Employee',
  'pages.employeeList.contractType.bpStudy': 'BP Employee Studying',
  'pages.employeeList.contractType.bpEnrolled': 'BP Employee Enrolled',

  // 社員一覧管理 - 编辑弹窗
  'pages.employeeList.edit.title': 'Edit Employee Info',
  'pages.employeeList.edit.personalInfo': 'Personal Info',
  'pages.employeeList.edit.visaInfo': 'Residence Info',
  'pages.employeeList.edit.employmentInfo': 'Employment Info',
  'pages.employeeList.edit.bankInfo': 'Bank Account',
  'pages.employeeList.edit.basicInfo': 'Basic Personal Info',
  'pages.employeeList.edit.contactInfo': 'Contact Info',
  'pages.employeeList.edit.contractInfo': 'Contract Info',
  'pages.employeeList.edit.orgInfo': 'Organization & Period',
  'pages.employeeList.edit.visaCardInfo': 'Residence Card Info',
  'pages.employeeList.edit.bankAccountInfo': 'Bank Account Info',
  'pages.employeeList.edit.remarksInfo': 'Remarks Section',

  // 社員一覧管理 - 表单字段标签
  'pages.employeeList.field.firstNameKanji': 'Last Name (Kanji)',
  'pages.employeeList.field.lastNameKanji': 'First Name (Kanji)',
  'pages.employeeList.field.firstNameKana': 'Last Name (Kana)',
  'pages.employeeList.field.lastNameKana': 'First Name (Kana)',
  'pages.employeeList.field.firstNameRoma': 'Last Name (Roma)',
  'pages.employeeList.field.lastNameRoma': 'First Name (Roma)',
  'pages.employeeList.field.gender': 'Gender',
  'pages.employeeList.field.birthday': 'Birthday',
  'pages.employeeList.field.nationality': 'Nationality',
  'pages.employeeList.field.phone': 'Phone',
  'pages.employeeList.field.mobile': 'Mobile',
  'pages.employeeList.field.postalCode': 'Postal Code',
  'pages.employeeList.field.mailAddress': 'Email',
  'pages.employeeList.field.address': 'Address',
  'pages.employeeList.field.visaCardNo': 'Residence Card No.',
  'pages.employeeList.field.visaType': 'Visa Type',
  'pages.employeeList.field.visaValidTo': 'Card Valid Until',
  'pages.employeeList.field.visaFromDate': 'Residence Period (From)',
  'pages.employeeList.field.visaToDate': 'Residence Period (To)',
  'pages.employeeList.field.individualNumber': 'Individual No.',
  'pages.employeeList.field.accountId': 'Account ID',
  'pages.employeeList.field.division': 'Division',
  'pages.employeeList.field.contractType': 'Affiliation Type',
  'pages.employeeList.field.regularConfirmStatus': 'Regular Confirm',
  'pages.employeeList.field.department': 'Department',
  'pages.employeeList.field.position': 'Position',
  'pages.employeeList.field.joiningDate': 'Joining Date',
  'pages.employeeList.field.departureDate': 'Departure Date',
  'pages.employeeList.field.contractPeriodFrom': 'Contract Period (From)',
  'pages.employeeList.field.contractPeriodTo': 'Contract Period (To)',
  'pages.employeeList.field.employmentInsuranceNo': 'Employment Insurance',
  'pages.employeeList.field.healthInsurerNo': 'Insurer Number',
  'pages.employeeList.field.healthInsuranceSymbol': 'Insured Certificate Symbol',
  'pages.employeeList.field.healthInsuranceNo': 'Insured Certificate Number',
  'pages.employeeList.healthInsurance.help':
    'All three fields may be left blank. If one is entered, all three must be completed.',
  'pages.employeeList.healthInsurance.incomplete':
    'Enter the insurer number, insured certificate symbol, and insured certificate number together.',
  'pages.employeeList.healthInsurance.digitsOnly': 'Enter digits only.',
  'pages.employeeList.healthInsurance.maxLength': 'Enter no more than 30 digits.',
  'pages.employeeList.field.bankName': 'Bank Name',
  'pages.employeeList.field.bankBranch': 'Branch Name',
  'pages.employeeList.field.bankAccountType': 'Account Type',
  'pages.employeeList.field.bankAccountNo': 'Account No.',
  'pages.employeeList.field.bankAccountHolder': 'Account Holder',
  'pages.employeeList.field.remarks': 'Remarks',

  // 社員一覧管理 - 表单选项值
  'pages.employeeList.option.nationality.china': 'China',
  'pages.employeeList.option.nationality.japan': 'Japan',
  'pages.employeeList.option.nationality.other': 'Other',
  'pages.employeeList.option.division.hq': 'HQ',
  'pages.employeeList.option.division.ec': 'EC',
  'pages.employeeList.option.regularConfirm.unconfirmed': 'Unconfirmed',
  'pages.employeeList.option.regularConfirm.confirmed': 'Confirmed OK',
  'pages.employeeList.option.regularConfirm.rejected': 'Postponed',
  'pages.employeeList.option.accountType.normal': 'Normal',
  'pages.employeeList.option.accountType.current': 'Current',
  'pages.employeeList.option.accountType.savings': 'Savings',

  // 社員一覧管理 - 在留資格选项
  'pages.employeeList.visaType.unset': 'Unset',
  'pages.employeeList.visaType.engineer': 'Engineer/Specialist',
  'pages.employeeList.visaType.highlySkilled1': 'Highly Skilled 1',
  'pages.employeeList.visaType.highlySkilled2': 'Highly Skilled 2',
  'pages.employeeList.visaType.business': 'Business Management',
  'pages.employeeList.visaType.intraCompany': 'Intra-company Transferee',
  'pages.employeeList.visaType.permanent': 'Permanent Resident',
  'pages.employeeList.visaType.other': 'Other',

  // 社員一覧管理 - 按钮和消息
  'pages.employeeList.btn.cancel': 'Cancel',
  'pages.employeeList.btn.save': 'Save',
  'pages.employeeList.btn.edit': 'Edit',
  'pages.employeeList.msg.loading': 'Reloading...',
  'pages.employeeList.msg.reloadSuccess': 'Update completed',
  'pages.employeeList.msg.searchFailed': 'Search failed.',
  'pages.employeeList.msg.fetchFailed': 'Failed to fetch employee info.',
  'pages.employeeList.msg.saveSuccess': 'Saved successfully.',
  'pages.employeeList.msg.saveFailed': 'Failed to save.',

  // 社員一覧管理 - 时间单位
  'pages.employeeList.unit.year': 'years',
  'pages.employeeList.unit.month': 'months',
  'pages.employeeList.unit.day': 'days',
  'pages.employeeList.status.expired': 'Expired',

  // Account Management Page
  'pages.dashboard.title': 'HR Dashboard',
  'pages.dashboard.refresh': 'Refresh',
  'pages.dashboard.quickAccess': 'Quick Access',
  'pages.dashboard.traineeList': 'Trainee List',
  'pages.dashboard.regularList': 'Employee List',
  'pages.dashboard.bpList': 'BP List',
  'pages.dashboard.distribution': 'Distribution',
  'pages.dashboard.total': 'Total',
  'pages.dashboard.viewAll': 'View All →',
  'pages.dashboard.activeStatus': 'Active Status',
  'pages.dashboard.totalActive': 'Active Employees',
  'pages.dashboard.trainee': 'Employment-Oriented',
  'pages.dashboard.regular': 'Employee',
  'pages.dashboard.bp': 'BP Employee',
  'pages.dashboard.terminated': 'Relationship Ended',
  'pages.dashboard.dropout': 'Training Dropout',
  'pages.dashboard.resigned': 'Resigned',
  'pages.dashboard.bpFinished': 'BP Finished',
  'pages.dashboard.actionRequired': 'Action Required',
  'pages.dashboard.visaRenewal': 'Residence Renewal (Within 90 Days)',
  'pages.dashboard.interviewWait': 'Conversion Interview Pending',
  'pages.dashboard.contractWait': 'Contract Conversion Pending',
  'pages.dashboard.birthdayThisMonth': 'Birthday This Month',
  'pages.dashboard.traineeVisaRenewal':
    'Residence Status Change / Renewal (Trainee - Offer Accepted)',
  'pages.dashboard.people': 'people',
  'pages.dashboard.msg.loadFailed': 'Failed to load dashboard data.',
  'pages.dashboard.bpFinishedTitle': 'Project Termination History',

  // Role Management Page
  'pages.roleManagement.selectedDelete': 'Role Name',
  'pages.roleManagement.roleDescription': 'Role Description',
  'pages.roleManagement.operation': 'Actions',
  'pages.roleManagement.roleList': 'Role List',
  'pages.roleManagement.createRole': 'Create Role',
  'pages.roleManagement.updateRole': 'Update Role',
  'pages.roleManagement.ruleNameIsRequired': 'Role name is required',

  // Page Authorization Management
  'pages.pageAuthManagement.pageId': 'Page ID',
  'pages.pageAuthManagement.pageName': 'Page Name',
  'pages.pageAuthManagement.description': 'Page Description',
  'pages.pageAuthManagement.operation': 'Actions',
  'pages.pageAuthManagement.auth': 'Edit Permissions',
  'pages.pageAuthManagement.update': 'Apply Settings',
  'pages.pageAuthManagement.serachList': 'Search Results',
  'pages.pageAuthManagement.searchList': 'Search Results',
  'pages.pageAuthManagement.title': 'Page Permission Management',
  'pages.pageAuthManagement.search.button': 'Search',
  'pages.pageAuthManagement.search.placeholder': 'Search by page ID / page name / description',
  'pages.pageAuthManagement.search.result': 'Search Results',
  'pages.pageAuthManagement.search.countUnit': 'items',
  'pages.pageAuthManagement.reload': 'Reload',
  'pages.pageAuthManagement.filter.keyword': 'Search',
  'pages.pageAuthManagement.filter.all': 'All',
  'pages.pageAuthManagement.filter.department': 'Department',
  'pages.pageAuthManagement.department.all': 'All',
  'pages.pageAuthManagement.department.humanResources': 'Human Resources',
  'pages.pageAuthManagement.department.development': 'Development',
  'pages.pageAuthManagement.department.generalAffairs': 'General Affairs',
  'pages.pageAuthManagement.department.sales': 'Sales',
  'pages.pageAuthManagement.department.accounting': 'Accounting',
  'pages.pageAuthManagement.department.systemSettings': 'System Settings',
  'pages.pageAuthManagement.department.common': 'Common',
  'pages.pageAuthManagement.permissionSummary.title': 'Permission Summary',
  'pages.pageAuthManagement.permissionSummary.expandHint': 'Expand to view',
  'pages.pageAuthManagement.permissionSummary.loading': 'Loading',
  'pages.pageAuthManagement.permissionSummary.loaded':
    '{operationCount} permissions / {roleCount} roles',
  'pages.pageAuthManagement.permissionSummary.empty': 'No permission information.',
  'pages.pageAuthManagement.permissionSummary.unset': 'Not Set',
  'pages.pageAuthManagement.load.failed': 'Failed to load page list.',
  'pages.pageAuthManagement.auth.loadFailed': 'Failed to load page permission settings.',
  'pages.pageAuthManagement.modal.title': 'Edit Page Permissions',
  'pages.pageAuthManagement.modal.operationCount': 'Operations',
  'pages.pageAuthManagement.modal.selectedRoleCount': 'Selected',
  'pages.pageAuthManagement.modal.readonly':
    'You do not have update permission. This dialog is read-only.',
  'pages.pageAuthManagement.action.save': 'Save',
  'pages.pageAuthManagement.action.cancel': 'Cancel',
  'pages.pageAuthManagement.action.saveAnyway': 'Save Anyway',
  'pages.pageAuthManagement.emptyRole.confirmTitle': 'Some operations have no roles.',
  'pages.pageAuthManagement.emptyRole.confirmDescription':
    'The following operations will not be assigned to any role. Do you want to save anyway?',
  'pages.pageAuthManagement.update.process': 'Updating page permissions...',
  'pages.pageAuthManagement.update.done': 'Page permissions updated successfully.',
  'pages.pageAuthManagement.update.failed': 'Failed to update page permissions.',

  // Learning Management - Player Page
  'pages.learnPlayer.home': 'Home',
  'pages.learnPlayer.course': 'Course',
  'pages.learnPlayer.downloadMaterials': 'Download Materials',
  'pages.learnPlayer.backToHome': 'Back to Home',
  'pages.learnPlayer.menuArea': 'Menu Area',
  'pages.learnPlayer.testPage': 'Go to Test Page',
  'pages.learnPlayer.download': 'Download',
  'pages.learnPlayer.playlist': 'Playlist',
  'pages.learnPlayer.currentPlaying': 'Currently Playing',
  'pages.learnPlayer.questionSubmit': 'Submit Question',
  'pages.learnPlayer.title': 'Title',
  'pages.learnPlayer.titlePlaceholder': 'Please enter question title (5-30 characters)',
  'pages.learnPlayer.titleRequired': 'Please enter title',
  'pages.learnPlayer.titleMin': 'Title must be at least 5 characters',
  'pages.learnPlayer.titleMax': 'Title must be at most 30 characters',
  'pages.learnPlayer.content': 'Content',
  'pages.learnPlayer.contentPlaceholder': 'Please enter question content (10-20000 characters)',
  'pages.learnPlayer.contentRequired': 'Please enter question content',
  'pages.learnPlayer.contentMin': 'Content must be at least 10 characters',
  'pages.learnPlayer.contentMax': 'Content must be at most 20000 characters',
  'pages.learnPlayer.attachments': 'Attachments',
  'pages.learnPlayer.uploadFile': 'Upload File',
  'pages.learnPlayer.submit': 'Submit',
  'pages.learnPlayer.submitSuccess': 'Question submitted successfully',
  'pages.learnPlayer.qa': 'Q&A',
  'pages.learnPlayer.noQuestions': 'No questions yet',
  'pages.learnPlayer.resolved': 'Resolved',
  'pages.learnPlayer.unresolved': 'Unresolved',
  'pages.learnPlayer.getCourseInfoFailed': 'Failed to get course information',
  'pages.learnPlayer.getQuestionsFailed': 'Failed to get question list',
  'pages.learnPlayer.submitQuestionFailed': 'Failed to submit question',
  'pages.learnPlayer.downloadFunctionPending': 'Download function pending',

  // Learning Management - Test Page
  'pages.learnTest.testPage': 'Test Page',
  'pages.learnTest.test': 'Test',
  'pages.learnTest.loading': 'Loading...',
  'pages.learnTest.singleChoice': 'Single Choice',
  'pages.learnTest.multipleChoice': 'Multiple Choice',
  'pages.learnTest.mark': 'Mark',
  'pages.learnTest.unmark': 'Unmark',
  'pages.learnTest.previous': 'Previous',
  'pages.learnTest.next': 'Next',
  'pages.learnTest.answerSheet': 'Answer Sheet',
  'pages.learnTest.answered': 'Answered',
  'pages.learnTest.current': 'Current',
  'pages.learnTest.marked': 'Marked',
  'pages.learnTest.submit': 'Submit',
  'pages.learnTest.abandon': 'Abandon',
  'pages.learnTest.confirmSubmit': 'Confirm Submit',
  'pages.learnTest.confirmSubmitContent':
    'Are you sure you want to submit the test answers? You cannot modify after submission.',
  'pages.learnTest.confirmAbandon': 'Confirm Abandon',
  'pages.learnTest.confirmAbandonContent':
    'Are you sure you want to abandon the test? All answers will be reset.',
  'pages.learnTest.submitSuccess': 'Test submitted successfully',
  'pages.learnTest.submitFailed': 'Failed to submit test',
  'pages.learnTest.getTestInfoFailed': 'Failed to get test information',
  'pages.learnTest.getQuestionsFailed': 'Failed to get test questions',
  'pages.learnTest.retryRequiredMessage':
    'Your correct rate is below 60%, so you need to relearn this lesson. After watching the video to the end, you can take the test again.',

  // Learning Management - Question Page
  'pages.learnQuestion.questionPage': '*Question Page',
  'pages.learnQuestion.answerQuestion': 'Answer Question',
  'pages.learnQuestion.answerContent': 'Answer Content',
  'pages.learnQuestion.answerContentPlaceholder':
    'Please enter answer content (10-20000 characters)',
  'pages.learnQuestion.answerContentRequired': 'Please enter answer content',
  'pages.learnQuestion.answerContentMin': 'Content must be at least 10 characters',
  'pages.learnQuestion.answerContentMax': 'Content must be at most 20000 characters',
  'pages.learnQuestion.uploadFile': 'Upload File',
  'pages.learnQuestion.cancel': 'Cancel',
  'pages.learnQuestion.post': 'Post',
  'pages.learnQuestion.answers': 'Answers',
  'pages.learnQuestion.noAnswers': 'No answers yet',
  'pages.learnQuestion.attachments': 'Attachments:',
  'pages.learnQuestion.statusUpdateSuccess': 'Status updated successfully',
  'pages.learnQuestion.answerSubmitSuccess': 'Answer submitted successfully',
  'pages.learnQuestion.answerSubmitFailed': 'Failed to submit answer',
  'pages.learnQuestion.getQuestionFailed': 'Failed to get question details',
  'pages.learnQuestion.getAnswersFailed': 'Failed to get answer list',

  // Learning Management - Analytics - Level Titles
  'pages.learnAnalytics.levelTitle.SSR': 'Legendary Full Stack',
  'pages.learnAnalytics.levelTitle.SS': 'Bug Instant Kill Sniper',
  'pages.learnAnalytics.levelTitle.S': 'Spec Reader',
  'pages.learnAnalytics.levelTitle.A': 'Serious Commit Craftsman',
  'pages.learnAnalytics.levelTitle.B': 'Works-is-Enough School',
  'pages.learnAnalytics.levelTitle.C': 'Debug Swamp Diver',
  'pages.learnAnalytics.levelTitle.D': 'Compile Error Craftsman',
  'pages.learnAnalytics.levelTitle.E': 'PC Restart Master',

  // Learning Management - Analytics
  'pages.development.learnManagement.analytics.participantName': 'Participant Name',
  'pages.development.learnManagement.analytics.department': 'Department',
  'pages.development.learnManagement.analytics.level': 'Level',
  'pages.development.learnManagement.analytics.totalScore': 'Total Score',
  'pages.development.learnManagement.analytics.points': 'points',
  'pages.development.learnManagement.analytics.averageCompletionRate': 'Average Completion Rate',
  'pages.development.learnManagement.analytics.averageCorrectRate': 'Average Correct Rate',
  'pages.development.learnManagement.player.testAfterLearning': 'Test After Learning',
  'pages.development.learnManagement.player.testLockedTooltip':
    'Watch the video to the end to unlock the test.',
  'pages.development.learnManagement.analytics.learningHours': 'Learning Hours',
  'pages.development.learnManagement.analytics.hours': 'h',
  'pages.development.learnManagement.analytics.timeScore': 'Time Score',
  'pages.development.learnManagement.analytics.statusStatistics': 'Status Statistics',
  'pages.development.learnManagement.analytics.recalculateLevel': 'Recalculate Level',
  'pages.development.learnManagement.analytics.recalculateSuccess': 'Level recalculation completed',
  'pages.development.learnManagement.analytics.recalculateFailed': 'Level recalculation failed',
  'pages.development.learnManagement.analytics.statusStatisticsError':
    'Failed to get status statistics',
  'pages.development.learnManagement.analytics.total': 'Total',
  'pages.development.learnManagement.analytics.person': 'persons',
  'pages.development.learnManagement.analytics.personUnit': 'persons',
  'pages.development.learnManagement.analytics.academicYear': 'Academic Year',
  'pages.development.learnManagement.analytics.selectAcademicYear': 'Select Academic Year',
  'pages.development.learnManagement.analytics.class': 'Class',
  'pages.development.learnManagement.analytics.className': 'Class Name',
  'pages.development.learnManagement.analytics.selectClass': 'Select Class',
  'pages.development.learnManagement.analytics.completionStatus': 'Completion Status',
  'pages.development.learnManagement.analytics.notCompleted': 'Not Completed',
  'pages.development.learnManagement.analytics.completed': 'Completed',

  // Learning Management - Progress
  'pages.development.learnManagement.progress.title': 'Learning Progress List',
  'pages.development.learnManagement.progress.courseProgressTab': 'By Course Progress',
  'pages.development.learnManagement.progress.testTab': 'Computer Test',
  'pages.development.learnManagement.progress.courseProgressHeader':
    'Learning Progress List (By Course Progress)',
  'pages.development.learnManagement.progress.testProgressHeader':
    'Learning Progress List (Computer Test)',
  'pages.development.learnManagement.progress.participantName': 'Participant Name',
  'pages.development.learnManagement.progress.completionRate': 'Completion Rate',
  'pages.development.learnManagement.progress.learningHours': 'Learning Hours',
  'pages.development.learnManagement.progress.testName': 'Test Name',
  'pages.development.learnManagement.progress.score': 'Score',
  'pages.development.learnManagement.progress.passFail': 'Pass/Fail',
  'pages.development.learnManagement.progress.completedDate': 'Completed Date',
  'pages.development.learnManagement.progress.academicYear': 'Academic Year',
  'pages.development.learnManagement.progress.status': 'Status',
  'pages.development.learnManagement.progress.selectAcademicYear': 'Select Academic Year',
  'pages.development.learnManagement.progress.selectStatus': 'Select Status',
  'pages.development.learnManagement.progress.selectParticipantName': 'Select Participant Name',
  'pages.development.learnManagement.progress.selectTestName': 'Select Test Name',
  'pages.development.learnManagement.progress.passed': 'Passed',
  'pages.development.learnManagement.progress.selectPassed': 'Select Passed',
  'pages.development.learnManagement.progress.notTaken': 'Not Taken',
  'pages.development.learnManagement.progress.passedStatus': 'Passed',
  'pages.development.learnManagement.progress.failed': 'Failed',
  'pages.development.learnManagement.progress.listView': 'List View',
  'pages.development.learnManagement.progress.matrixView': 'Matrix View',
  'pages.development.learnManagement.progress.filterOptionsError': 'Failed to get filter options',
  'pages.development.learnManagement.progress.matrixTitle':
    'Computer Test Questions / Participants',
  'pages.development.learnManagement.progress.testDescription':
    'You can check test scores for each participant',
  'pages.development.learnManagement.progress.noData':
    'No data available. Please load test score data first.',
  'pages.development.learnManagement.progress.matrixDescription':
    "* Scores ≥80 highlighted in green; ≥60 in blue; <60 in red and bold. Not taken shows '-'. Matrix view facilitates horizontal comparison of participants' scores.",
  'pages.development.learnManagement.progress.statusNotStarted': 'Not Started',
  'pages.development.learnManagement.progress.statusInProgress': 'In Progress',
  'pages.development.learnManagement.progress.statusCompleted': 'Completed',
  'pages.development.learnManagement.progress.statusOverdue': 'Overdue',

  // Learning Management - Course Management
  'pages.development.learnManagement.course.largeCourseTab': 'Large Course',
  'pages.development.learnManagement.course.mediumCourseTab': 'Medium Course',
  'pages.development.learnManagement.course.largeCourse': 'Large Course',
  'pages.development.learnManagement.course.mediumCourse': 'Medium Course',
  'pages.development.learnManagement.course.largeCourseName': 'Large Course Name',
  'pages.development.learnManagement.course.largeCourseDescription': 'Large Course Description',
  'pages.development.learnManagement.course.mediumCourseName': 'Medium Course Name',
  'pages.development.learnManagement.course.mediumCourseCode': 'Medium Course Code',
  'pages.development.learnManagement.course.mediumCourseDescription': 'Medium Course Description',
  'pages.development.learnManagement.course.smallCourseCount': 'Small Course Count',
  'pages.development.learnManagement.course.learningProgressName': 'Learning Progress Name',
  'pages.development.learnManagement.course.learningTimeMinutes': 'Learning Time (minutes)',
  'pages.development.learnManagement.course.learningTimeMinutesPlaceholder':
    'Please enter learning time (minutes)',
  'pages.development.learnManagement.course.practiceQuestionCount': 'Practice Question Count',
  'pages.development.learnManagement.course.createdDate': 'Created Date',
  'pages.development.learnManagement.course.createDate': 'Created Date',
  'pages.development.learnManagement.course.operation': 'Operation',
  'pages.development.learnManagement.course.update': 'Update',
  'pages.development.learnManagement.course.delete': 'Delete',
  'pages.development.learnManagement.course.addLargeCourse': 'Add Large Course',
  'pages.development.learnManagement.course.addMediumCourse': 'Add Medium Course',
  'pages.development.learnManagement.course.addSmallCourse': 'Add Small Course',
  'pages.development.learnManagement.course.largeCourseAdd': 'Add Large Course',
  'pages.development.learnManagement.course.mediumCourseAdd': 'Add Medium Course',
  'pages.development.learnManagement.course.smallCourseAdd': 'Add Small Course',
  'pages.development.learnManagement.course.batchDelete': 'Batch Delete',
  'pages.development.learnManagement.course.testManagement': 'Test Management',
  'pages.development.learnManagement.course.largeCourseManagement': 'Large Course Management',
  'pages.development.learnManagement.course.mediumCourseManagement': 'Medium Course Management',
  'pages.development.learnManagement.course.smallCourseList': 'Small Course List',
  'pages.development.learnManagement.course.largeCourseDeleteConfirm':
    'Confirm Large Course Deletion',
  'pages.development.learnManagement.course.largeCourseDeleteDescription':
    'Are you sure you want to delete this large course?',
  'pages.development.learnManagement.course.largeCourseDeleteConfirmTitle':
    'Confirm Large Course Deletion',
  'pages.development.learnManagement.course.largeCourseDeleteConfirmDescription':
    'Are you sure you want to delete this large course?',
  'pages.development.learnManagement.course.mediumCourseDeleteConfirm':
    'Confirm Medium Course Deletion',
  'pages.development.learnManagement.course.mediumCourseDeleteDescription':
    'Are you sure you want to delete this medium course?',
  'pages.development.learnManagement.course.mediumCourseDeleteConfirmTitle':
    'Confirm Medium Course Deletion',
  'pages.development.learnManagement.course.mediumCourseDeleteConfirmDescription':
    'Are you sure you want to delete this medium course?',
  'pages.development.learnManagement.course.smallCourseDeleteConfirm':
    'Confirm Small Course Deletion',
  'pages.development.learnManagement.course.smallCourseDeleteDescription':
    'Are you sure you want to delete this small course?',
  'pages.development.learnManagement.course.smallCourseDeleteConfirmTitle':
    'Confirm Small Course Deletion',
  'pages.development.learnManagement.course.smallCourseDeleteConfirmDescription':
    'Are you sure you want to delete this small course?',
  'pages.development.learnManagement.course.cancel': 'Cancel',
  'pages.development.learnManagement.course.largeCourseDeleting': 'Deleting large course...',
  'pages.development.learnManagement.course.largeCourseDeleted':
    'Large course deleted, will be updated shortly.',
  'pages.development.learnManagement.course.largeCourseDeleteFailed':
    'Failed to delete large course',
  'pages.development.learnManagement.course.largeCourseAdding': 'Adding large course...',
  'pages.development.learnManagement.course.largeCourseAdded': 'Large course added.',
  'pages.development.learnManagement.course.largeCourseAddFailed': 'Failed to add large course',
  'pages.development.learnManagement.course.largeCourseUpdating': 'Updating large course...',
  'pages.development.learnManagement.course.largeCourseUpdated': 'Large course updated.',
  'pages.development.learnManagement.course.largeCourseUpdateFailed':
    'Failed to update large course',
  'pages.development.learnManagement.course.mediumCourseDeleting': 'Deleting medium course...',
  'pages.development.learnManagement.course.mediumCourseDeleted':
    'Medium course deleted, will be updated shortly.',
  'pages.development.learnManagement.course.mediumCourseDeleteFailed':
    'Failed to delete medium course',
  'pages.development.learnManagement.course.mediumCourseAdding': 'Adding medium course...',
  'pages.development.learnManagement.course.mediumCourseAdded': 'Medium course added.',
  'pages.development.learnManagement.course.mediumCourseAddFailed': 'Failed to add medium course',
  'pages.development.learnManagement.course.mediumCourseUpdating': 'Updating medium course...',
  'pages.development.learnManagement.course.mediumCourseUpdated': 'Medium course updated.',
  'pages.development.learnManagement.course.mediumCourseUpdateFailed':
    'Failed to update medium course',
  'pages.development.learnManagement.course.smallCourseDeleting': 'Deleting small course...',
  'pages.development.learnManagement.course.smallCourseDeleted':
    'Small course deleted, will be updated shortly.',
  'pages.development.learnManagement.course.smallCourseDeleteFailed':
    'Failed to delete small course',
  'pages.development.learnManagement.course.smallCourseAdding': 'Adding small course...',
  'pages.development.learnManagement.course.smallCourseAdded': 'Small course added.',
  'pages.development.learnManagement.course.smallCourseAddFailed': 'Failed to add small course',
  'pages.development.learnManagement.course.smallCourseUpdating': 'Updating small course...',
  'pages.development.learnManagement.course.smallCourseUpdated': 'Small course updated.',
  'pages.development.learnManagement.course.smallCourseUpdateFailed':
    'Failed to update small course',
  'pages.development.learnManagement.course.mediumCourseListError':
    'Failed to get medium course list',
  'pages.development.learnManagement.course.largeCourseUpdate': 'Update Large Course',
  'pages.development.learnManagement.course.largeCourseUpdateTitle': 'Update Large Course',
  'pages.development.learnManagement.course.largeCourseAddTitle': 'Add Large Course',
  'pages.development.learnManagement.course.largeCourseNamePlaceholder':
    'e.g., Frontend Basics Pack (HTML/CSS/JavaScript)',
  'pages.development.learnManagement.course.largeCourseNameRequired':
    'Please enter large course name',
  'pages.development.learnManagement.course.largeCourseDescriptionPlaceholder':
    'Please enter large course description',
  'pages.development.learnManagement.course.relatedMediumCourses': 'Related Medium Courses',
  'pages.development.learnManagement.course.relatedMediumCoursesPlaceholder':
    'Please select medium courses (multiple selection allowed)',
  'pages.development.learnManagement.course.selectMediumCourses':
    'Please select medium courses (multiple selection allowed)',
  'pages.development.learnManagement.course.mediumCourseUpdateTitle': 'Update Medium Course',
  'pages.development.learnManagement.course.mediumCourseAddTitle': 'Add Medium Course',
  'pages.development.learnManagement.course.mediumCourseNamePlaceholder':
    'Please enter medium course name',
  'pages.development.learnManagement.course.mediumCourseNameRequired':
    'Please enter medium course name',
  'pages.development.learnManagement.course.mediumCourseCodePlaceholder': 'e.g., HTML',
  'pages.development.learnManagement.course.mediumCourseDescriptionPlaceholder':
    'Please enter medium course description',
  'pages.development.learnManagement.course.mediumCourseStage': 'Stage',
  'pages.development.learnManagement.course.mediumCourseStagePlaceholder': 'Select stage',
  'pages.development.learnManagement.course.stage1': 'Stage 1: Frontend Learning',
  'pages.development.learnManagement.course.stage2': 'Stage 2',
  'pages.development.learnManagement.course.relatedLargeCourseId': 'Related Large Course ID',
  'pages.development.learnManagement.course.relatedLargeCourseIdPlaceholder':
    'Please enter related large course ID (optional)',
  'pages.development.learnManagement.course.trainingCourseId': 'Training Course ID',
  'pages.development.learnManagement.course.trainingCourseIdPlaceholder':
    'Please enter training course ID',
  'pages.development.learnManagement.course.trainingCourseIdRequired':
    'Please enter training course ID',
  'pages.development.learnManagement.course.courseStructure': 'Course Structure',
  'pages.development.learnManagement.course.courseStructurePlaceholder':
    'Please enter course structure',
  'pages.development.learnManagement.course.smallCourseUpdateTitle': 'Update Small Course',
  'pages.development.learnManagement.course.smallCourseAddTitle': 'Add Small Course',
  'pages.development.learnManagement.course.selectMediumCourse': 'Please select medium course',
  'pages.development.learnManagement.course.mediumCourseSelectPlaceholder':
    'Please select medium course',
  'pages.development.learnManagement.course.mediumCourseRequired': 'Please select medium course',
  'pages.development.learnManagement.course.smallCourseName': 'Small Course Name',
  'pages.development.learnManagement.course.smallCourseNamePlaceholder':
    'Please enter small course name',
  'pages.development.learnManagement.course.smallCourseNameRequired':
    'Please enter small course name',
  'pages.development.learnManagement.course.smallCourseDescription': 'Small Course Description',
  'pages.development.learnManagement.course.smallCourseDescriptionPlaceholder':
    'Please enter small course description',
  'pages.development.learnManagement.course.learningProgressNamePlaceholder':
    'Please enter learning progress name',
  'pages.development.learnManagement.course.learningProgressNameRequired':
    'Please enter learning progress name',
  'pages.development.learnManagement.course.learningTimePlaceholder': 'Please enter learning time',
  'pages.development.learnManagement.course.learningTimeRequired': 'Please enter learning time',
  'pages.development.learnManagement.course.smallCourseMinutes': 'Small Course Duration (minutes)',
  'pages.development.learnManagement.course.smallCourseMinutesPlaceholder':
    'Please enter small course duration (minutes)',
  'pages.development.learnManagement.course.smallCourseMinutesRequired':
    'Please enter small course duration (minutes)',
  'pages.development.learnManagement.course.learningTimeMinutesRequired':
    'Please enter learning time (minutes)',
  'pages.development.learnManagement.course.practiceQuestionCountPlaceholder':
    'Please enter practice question count',
  'pages.development.learnManagement.course.questionDeleted': 'Question deleted',
  'pages.development.learnManagement.course.questionDeleteFailed': 'Failed to delete question',
  'pages.development.learnManagement.course.questionUpdated': 'Question updated',
  'pages.development.learnManagement.course.questionAdded': 'Question added',
  'pages.development.learnManagement.course.operationFailed': 'Operation failed',
  'pages.development.learnManagement.course.questionDeleteConfirm': 'Confirm Question Deletion',
  'pages.development.learnManagement.course.questionDeleteDescription':
    'Are you sure you want to delete this question?',
  'pages.development.learnManagement.course.questionEdit': 'Edit Question',
  'pages.development.learnManagement.course.questionAdd': 'Add Question',
  'pages.development.learnManagement.course.addQuestion': 'Add Question',
  'pages.development.learnManagement.course.edit': 'Edit',
  'pages.development.learnManagement.course.questionContent': 'Question Content',
  'pages.development.learnManagement.course.questionContentPlaceholder':
    'Please enter question content',
  'pages.development.learnManagement.course.questionContentRequired':
    'Please enter question content',
  'pages.development.learnManagement.course.questionType': 'Question Type',
  'pages.development.learnManagement.course.questionTypeRequired': 'Please select question type',
  'pages.development.learnManagement.course.singleChoice': 'Single Choice',
  'pages.development.learnManagement.course.multipleChoice': 'Multiple Choice',
  'pages.development.learnManagement.course.addOption': 'Add Option',
  'pages.development.learnManagement.course.option': 'Option {index}',
  'pages.development.learnManagement.course.optionPlaceholder': 'Please enter option {index}',
  'pages.development.learnManagement.course.optionContentRequired': 'Please enter option content',
  'pages.development.learnManagement.course.optionsMinRequired': 'At least 2 options are required',
  'pages.development.learnManagement.course.correctAnswer': 'Correct Answer',
  'pages.development.learnManagement.course.correctAnswerRequired': 'Please select correct answer',
  'pages.development.learnManagement.course.correctAnswerAtLeastOneRequired':
    'Please select at least one correct answer',
  'pages.development.learnManagement.course.optionCount': 'Option Count',
  'pages.development.learnManagement.course.questionDeleteConfirmTitle':
    'Confirm Question Deletion',
  'pages.development.learnManagement.course.questionDeleteConfirmDescription':
    'Are you sure you want to delete this question?',
  'pages.development.learnManagement.course.qaAnswerRequired': 'Please select QA answer',
  'pages.development.learnManagement.course.qaComment': 'QA Comment',
  'pages.development.learnManagement.course.qaCommentPlaceholder': 'Please enter QA comment',
  'pages.development.learnManagement.course.qaChooseA': 'Option A',
  'pages.development.learnManagement.course.qaChooseAPlaceholder': 'Please enter option A',
  'pages.development.learnManagement.course.qaChooseARequired': 'Please enter option A',
  'pages.development.learnManagement.course.qaChooseB': 'Option B',
  'pages.development.learnManagement.course.qaChooseBPlaceholder': 'Please enter option B',
  'pages.development.learnManagement.course.qaChooseBRequired': 'Please enter option B',
  'pages.development.learnManagement.course.qaChooseC': 'Option C',
  'pages.development.learnManagement.course.qaChooseCPlaceholder': 'Please enter option C',
  'pages.development.learnManagement.course.qaChooseCRequired': 'Please enter option C',
  'pages.development.learnManagement.course.qaChooseD': 'Option D',
  'pages.development.learnManagement.course.qaChooseDPlaceholder': 'Please enter option D',
  'pages.development.learnManagement.course.qaChooseDRequired': 'Please enter option D',
  'pages.development.learnManagement.course.qaDeleteConfirmTitle': 'Confirm QA Deletion',
  'pages.development.learnManagement.course.qaDeleteConfirmDescription':
    'Are you sure you want to delete this QA?',
  'pages.development.learnManagement.course.mediumCourseRelationManagement':
    'Medium Course Relation Management',
  'pages.development.learnManagement.course.relationManagementTitle': 'Edit Course Information',
  'pages.development.learnManagement.course.reset': 'Reset',
  'pages.development.learnManagement.course.confirm': 'Confirm',
  'pages.development.learnManagement.course.relationLoadFailed':
    'Failed to load relation information',
  'pages.development.learnManagement.course.relationUpdated': 'Relation updated successfully',
  'pages.development.learnManagement.course.relationUpdateFailed': 'Failed to update relation',

  // Learning Management - Player
  'pages.development.learnManagement.player.saveProgressSuccess': 'Learning progress saved',
  'pages.development.learnManagement.player.saveProgressFailed': 'Failed to save learning progress',
  'pages.development.learnManagement.player.testIdNotSet': 'Test ID is not set',
  'pages.development.learnManagement.player.videoUrlNotSet': 'Video URL is not set',
  'pages.development.learnManagement.player.test': 'Test',
  'pages.development.learnManagement.player.play': 'Play',
  'pages.development.learnManagement.player.completeVideoFirst':
    'Please complete video viewing first',
  'pages.development.learnManagement.player.currentSection': 'Current Section',
  'pages.development.learnManagement.player.cancel': 'Cancel',
  'pages.development.learnManagement.player.confirm': 'Confirm',

  // Learning Management - Progress Levels
  'pages.development.learnManagement.progress.statusExcellent': 'Excellent · Stable',
  'pages.development.learnManagement.progress.statusGood': 'Good · Monitor',
  'pages.development.learnManagement.progress.statusAverage': 'Average · Follow-up',
  'pages.development.learnManagement.progress.statusFail': 'Risk · Intervention',
  'pages.development.learnManagement.progress.statusBomb': 'Risk · Intervention',
  'pages.development.learnManagement.progress.levelAndScore': 'Level / Score',
  'pages.development.learnManagement.progress.averageScore': 'Average Score',
  'pages.development.learnManagement.progress.learningTask': 'Learning Task',
  'pages.development.learnManagement.progress.learningRemark': 'Evaluation Remark',
  'pages.development.learnManagement.progress.operation': 'Operation',
  'pages.development.learnManagement.progress.noPermission': 'No Permission',
  'pages.development.learnManagement.progress.taskManagement': 'Task Management',
  'pages.development.learnManagement.progress.remarkManagement': 'Evaluation Remark Management',
  'pages.development.learnManagement.progress.mediumCourseName': 'Medium Course Name',
  'pages.development.learnManagement.progress.mediumCourseNameSelect':
    'Please Select Medium Course',
  'pages.development.learnManagement.progress.participantNameInput': 'e.g., Zhang San / Tanaka',
  'pages.development.learnManagement.progress.participantNameInputExample':
    'e.g., Zhang San / Tanaka',
  'pages.development.learnManagement.progress.recalcComplete':
    'Recalculation Complete: Processed {processedAccounts}, Inserted {insertedCount}, Updated {updatedCount}',
  'pages.development.learnManagement.progress.recalc': 'Recalculate',
  'pages.development.learnManagement.progress.taskInputRequired': 'Please Enter Learning Task',
  'pages.development.learnManagement.progress.taskUpdated': 'Task Updated',
  'pages.development.learnManagement.progress.taskInputPlaceholder': 'Enter Learning Task',
  'pages.development.learnManagement.progress.remarkUpdated': 'Remark Updated',
  'pages.development.learnManagement.progress.remarkInputPlaceholder':
    'Enter Evaluation and Comments (e.g., High learning motivation, Strong teamwork, etc.)',
  'pages.development.learnManagement.progress.remarkHint': 'Max 1000 characters',

  // General Affairs - Commute List
  'pages.commuteList.title': 'Transport Expense List',
  'pages.commuteList.employeeId': 'Employee ID',
  'pages.commuteList.progress': 'Progress',
  'pages.commuteList.employeeName': 'Employee Name',
  'pages.commuteList.amount': 'Amount',
  'pages.commuteList.submitStatus': 'Submit Status',
  'pages.commuteList.approvalStatus': 'Approval Status',
  'pages.commuteList.operation': 'Actions',
  'pages.commuteList.detail': 'Details',
  'pages.commuteList.remind': 'Remind',
  'pages.commuteList.remindConfirm': 'Send Reminder',
  'pages.commuteList.remindConfirmContent': 'Send submission reminder to "{name}"?',
  'pages.commuteList.remindSuccess': 'Reminder sent successfully',
  'pages.commuteList.remindFailed': 'Failed to send reminder',
  'pages.commuteList.all': 'All',
  'pages.commuteList.notApplied': 'Not Applied',
  'pages.commuteList.notAllSubmitted': 'In Progress',
  'pages.commuteList.allSubmitted': 'Pending Approval',
  'pages.commuteList.approved': 'Approved',
  'pages.commuteList.total': 'Total',
  'pages.commuteList.reload': 'Reload',
  'pages.commuteList.search.button': 'Search',
  'pages.commuteList.search.placeholder':
    'Search by employee ID / account name / employee name / submit status / approval status / amount',
  'pages.commuteList.search.result': 'Search results',
  'pages.commuteList.search.countUnit': 'items',
  'pages.commuteList.remindAll': 'Remind All',
  'pages.commuteList.noPermission': 'You do not have permission to use this feature.',
  'pages.commuteList.fetchFailed': 'Failed to get transport expense list.',
  'pages.commuteCommit.status.notSubmitted': 'Not Submitted',
  'pages.commuteCommit.status.pendingApproval': 'Pending Approval',
  'pages.commuteCommit.status.approved': 'Approved',
  'pages.commuteCommit.status.rejected': 'Returned',
  'pages.commuteCommit.reject.action': 'Reject',
  'pages.commuteCommit.reject.title': 'Reject Commute Expense (Return)',
  'pages.commuteCommit.reject.placeholder': 'Enter the rejection reason',
  'pages.commuteCommit.reject.ok': 'Return',
  'pages.commuteCommit.reject.cancel': 'Cancel',
  'pages.commuteCommit.reject.requireReason': 'Please enter a rejection reason.',
  'pages.commuteCommit.column.no': 'No',
  'pages.commuteCommit.column.commuteType': 'Commute Type',
  'pages.commuteCommit.column.period': 'Period',
  'pages.commuteCommit.column.amount': 'Amount',
  'pages.commuteCommit.column.status': 'Approval Status',
  'pages.commuteCommit.column.remarks': 'Remarks',
  'pages.commuteCommit.column.receipt': 'Receipt',
  'pages.commuteCommit.column.actions': 'Actions',
  'pages.commuteCommit.receipt.show': 'View',
  'pages.commuteCommit.receipt.none': 'No Receipt',
  'pages.commuteCommit.action.delete': 'Delete',
  'pages.commuteCommit.action.submit': 'Submit',
  'pages.commuteCommit.action.approve': 'Approve',
  'pages.commuteCommit.confirm.ok': 'Yes',
  'pages.commuteCommit.confirm.cancel': 'No',
  'pages.commuteCommit.delete.title': 'Confirm Delete',
  'pages.commuteCommit.delete.confirm': 'Are you sure you want to delete?',
  'pages.commuteCommit.submit.title': 'Confirm Submission',
  'pages.commuteCommit.submit.confirm': 'Submit this request?',
  'pages.commuteCommit.approve.title': 'Confirm Approval',
  'pages.commuteCommit.approve.confirm': 'Approve this request?',
  'pages.commuteCommit.header.month': '{year}/{month}',

  // Leave Requests (OARequests)
  'pages.oaRequests.title': 'Leave Requests',
  'pages.oaRequests.column.requestId': 'Request',
  'pages.oaRequests.column.status': 'Status',
  'pages.oaRequests.column.leavePeriod': 'Leave Period',
  'pages.oaRequests.column.reason': 'Reason',
  'pages.oaRequests.column.rejectReason': 'Reject Reason',
  'pages.oaRequests.column.approvalStep': 'Approval Step',
  'pages.oaRequests.column.actions': 'Actions',
  'pages.oaRequests.status.draft': 'Draft',
  'pages.oaRequests.status.submitted': 'Submitted',
  'pages.oaRequests.status.approved': 'Approved',
  'pages.oaRequests.status.rejected': 'Rejected',
  'pages.oaRequests.status.cancelled': 'Cancelled',
  'pages.oaRequests.action.detail': 'Detail',
  'pages.oaRequests.action.edit': 'Edit',
  'pages.oaRequests.action.submit': 'Submit',
  'pages.oaRequests.action.cancel': 'Cancel',
  'pages.oaRequests.action.delete': 'Delete',
  'pages.oaRequests.action.create': 'New Request',
  'pages.oaRequests.action.update': 'Update',
  'pages.oaRequests.action.saveDraft': 'Save Draft',
  'pages.oaRequests.action.createAndSubmit': 'Create & Submit',
  'pages.oaRequests.action.cancelBtn': 'Cancel',
  'pages.oaRequests.action.back': 'Back',
  'pages.oaRequests.modal.editTitle': 'Edit Leave Request',
  'pages.oaRequests.modal.createTitle': 'Create Leave Requests',
  'pages.oaRequests.drawer.title': 'Leave Request Detail',
  'pages.oaRequests.confirm.submit': 'Submit this leave request?',
  'pages.oaRequests.confirm.submitMultiple': 'Submit leave requests for this period?',
  'pages.oaRequests.confirm.submitDescription':
    'You cannot edit the request after submission. If you need to modify it, please cancel and re-apply.',
  'pages.oaRequests.confirm.cancel': 'Cancel this leave request?',
  'pages.oaRequests.confirm.cancelMultiple': 'Cancel leave requests for this period?',
  'pages.oaRequests.confirm.delete': 'Delete this cancelled leave request?',
  'pages.oaRequests.confirm.deleteMultiple': 'Delete cancelled leave requests for this period?',
  'pages.oaRequests.confirm.deleteDescription':
    'After deletion, the request will no longer be shown in the list.',
  'pages.oaRequests.field.leaveDate': 'Leave Date',
  'pages.oaRequests.field.leavePeriod': 'Leave Period',
  'pages.oaRequests.field.leaveType': 'Leave Type',
  'pages.oaRequests.field.leaveStartDate': 'Leave Start Date',
  'pages.oaRequests.field.leaveEndDate': 'Leave End Date',
  'pages.oaRequests.field.leaveStartTime': 'Start Time',
  'pages.oaRequests.field.leaveEndTime': 'End Time',
  'pages.oaRequests.field.reason': 'Leave Reason',
  'pages.oaRequests.leaveType.fullDay': 'Full-day Leave',
  'pages.oaRequests.leaveType.hourly': 'Hourly Leave',
  'pages.oaRequests.validation.leaveDate': 'Please select a leave date.',
  'pages.oaRequests.validation.leavePeriod': 'Please select a leave period.',
  'pages.oaRequests.confirm.longPeriodTitle': 'Long leave request',
  'pages.oaRequests.confirm.longPeriodDescription':
    'This request covers {days} days, exceeding the usual {warningDays} days. Confirm the year and date range before continuing.',
  'pages.oaRequests.confirm.longPeriodContinue': 'Confirm and continue',
  'pages.oaRequests.validation.leaveType': 'Please select a leave type.',
  'pages.oaRequests.validation.leaveStartDate': 'Please select a leave start date.',
  'pages.oaRequests.validation.leaveEndDate': 'Please select a leave end date.',
  'pages.oaRequests.validation.leaveDateOrder':
    'Leave end date must be on or after the start date.',
  'pages.oaRequests.validation.leaveStartTime': 'Please select a start time.',
  'pages.oaRequests.validation.leaveEndTime': 'Please select an end time.',
  'pages.oaRequests.validation.leaveTimeRange':
    'Time must be between 08:00 and 20:00 in 15-minute increments.',
  'pages.oaRequests.validation.leaveTimeOrder': 'End time must be later than start time.',
  'pages.oaRequests.validation.reason': 'Please enter a leave reason.',
  'pages.oaRequests.msg.submitSuccess': 'Leave request submitted.',
  'pages.oaRequests.msg.submitMultipleSuccess': '{count} leave requests submitted.',
  'pages.oaRequests.msg.submitFailed': 'Failed to submit leave request.',
  'pages.oaRequests.msg.cancelSuccess': 'Leave request cancelled.',
  'pages.oaRequests.msg.cancelMultipleSuccess': '{count} leave requests cancelled.',
  'pages.oaRequests.msg.cancelFailed': 'Failed to cancel leave request.',
  'pages.oaRequests.msg.deleteSuccess': 'Cancelled leave request deleted.',
  'pages.oaRequests.msg.deleteMultipleSuccess': '{count} cancelled leave requests deleted.',
  'pages.oaRequests.msg.deleteFailed': 'Failed to delete cancelled leave request.',
  'pages.oaRequests.msg.updateSuccess': 'Leave request updated.',
  'pages.oaRequests.msg.updateFailed': 'Failed to update leave request.',
  'pages.oaRequests.msg.createSuccess': 'Leave requests created.',
  'pages.oaRequests.msg.createAndSubmitSuccess': 'Leave requests submitted.',
  'pages.oaRequests.msg.createFailed': 'Failed to save leave requests.',
  'pages.oaRequests.msg.detailFailed': 'Failed to get leave request detail.',
  'pages.oaRequests.detail.requestId': 'Request ID',
  'pages.oaRequests.detail.applicant': 'Applicant',
  'pages.oaRequests.detail.status': 'Status',
  'pages.oaRequests.detail.leaveDate': 'Leave Date',
  'pages.oaRequests.detail.leaveType': 'Leave Type',
  'pages.oaRequests.detail.leaveTime': 'Time Range',
  'pages.oaRequests.detail.leaveDuration': 'Leave Duration',
  'pages.oaRequests.detail.approvalStep': 'Approval Step',
  'pages.oaRequests.detail.originalInTime': 'Original In Time',
  'pages.oaRequests.detail.originalBreakTime': 'Original Break Time',
  'pages.oaRequests.detail.originalOutTime': 'Original Out Time',
  'pages.oaRequests.detail.reason': 'Leave Reason',
  'pages.oaRequests.detail.rejectReason': 'Reject Reason',
  'pages.oaRequests.detail.leaveFlag': 'Leave',
  'pages.oaRequests.detail.workFlag': 'Work',
  'pages.oaRequests.itemCount': '{count} items',
  'pages.oaRequests.dayCount': '{count} days',
  'pages.oaRequests.approvalHistory.step': 'STEP',
  'pages.oaRequests.approvalHistory.stepName': 'Step Name',
  'pages.oaRequests.approvalHistory.approverRole': 'Approver Role',
  'pages.oaRequests.approvalHistory.status': 'Status',
  'pages.oaRequests.approvalHistory.actionBy': 'Action By',
  'pages.oaRequests.approvalHistory.comment': 'Comment',
  'pages.oaRequests.approvalHistory.actionAt': 'Action At',

  // Leave Approvals (OAApprovals)
  'pages.oaApprovals.title': 'Leave Approvals',
  'pages.oaApprovals.tab.pending': 'Pending',
  'pages.oaApprovals.tab.history': 'History',
  'pages.oaApprovals.historyScope.all': 'All',
  'pages.oaApprovals.historyScope.mine': 'Handled by Me',
  'pages.oaApprovals.column.request': 'Request',
  'pages.oaApprovals.column.applicant': 'Applicant',
  'pages.oaApprovals.column.status': 'Status',
  'pages.oaApprovals.column.leavePeriod': 'Leave Period',
  'pages.oaApprovals.column.approvalStep': 'Approval Step',
  'pages.oaApprovals.column.reason': 'Reason',
  'pages.oaApprovals.column.appliedAt': 'Applied At',
  'pages.oaApprovals.column.actionAt': 'Action At',
  'pages.oaApprovals.column.actions': 'Actions',
  'pages.oaApprovals.action.detail': 'Detail',
  'pages.oaApprovals.action.approve': 'Approve',
  'pages.oaApprovals.action.reject': 'Reject',
  'pages.oaApprovals.confirm.approve': 'Approve this leave request?',
  'pages.oaApprovals.confirm.approveMultiple': 'Approve leave requests for this period?',
  'pages.oaApprovals.confirm.back': 'Back',
  'pages.oaApprovals.reject.title': 'Reject',
  'pages.oaApprovals.reject.reason': 'Reject Reason',
  'pages.oaApprovals.reject.validation': 'Please enter a reject reason.',
  'pages.oaApprovals.msg.loadFailed': 'Failed to load leave approvals.',
  'pages.oaApprovals.msg.detailFailed': 'Failed to get leave request detail.',
  'pages.oaApprovals.msg.approveSuccess': 'Leave request approved.',
  'pages.oaApprovals.msg.approveMultipleSuccess': '{count} leave requests approved.',
  'pages.oaApprovals.msg.approveFailed': 'Failed to approve leave request.',
  'pages.oaApprovals.msg.rejectSuccess': 'Leave request rejected.',
  'pages.oaApprovals.msg.rejectMultipleSuccess': '{count} leave requests rejected.',
  'pages.oaApprovals.msg.rejectFailed': 'Failed to reject leave request.',
  'pages.oaApprovals.drawer.title': 'Leave Request Detail',
  'pages.oaApprovals.summary.leaveRequest': 'Leave Request {label}',
  'pages.oaApprovals.summary.requestId': 'Request ID: {ids}',
  'pages.oaApprovals.summary.periodMultiple': '{count} days',
  'pages.oaApprovals.summary.periodSingle': '1 day',
  'pages.oaApprovals.detail.requestId': 'Request ID',
  'pages.oaApprovals.detail.applicant': 'Applicant',
  'pages.oaApprovals.detail.status': 'Status',
  'pages.oaApprovals.detail.leaveDate': 'Leave Date',
  'pages.oaApprovals.detail.originalInTime': 'Original In Time',
  'pages.oaApprovals.detail.originalBreakTime': 'Original Break Time',
  'pages.oaApprovals.detail.originalOutTime': 'Original Out Time',
  'pages.oaApprovals.detail.reason': 'Leave Reason',
  'pages.oaApprovals.detail.rejectReason': 'Reject Reason',

  // Leave Workflows (OAWorkflows)
  'pages.oaWorkflows.title': 'Leave Workflows',
  'pages.oaWorkflows.column.workflowName': 'Workflow Name',
  'pages.oaWorkflows.column.active': 'Active',
  'pages.oaWorkflows.column.steps': 'Approval Steps',
  'pages.oaWorkflows.column.actions': 'Actions',
  'pages.oaWorkflows.action.edit': 'Edit',
  'pages.oaWorkflows.modal.editTitle': 'Edit Leave Workflow',
  'pages.oaWorkflows.field.workflowName': 'Workflow Name',
  'pages.oaWorkflows.field.active': 'Active',
  'pages.oaWorkflows.field.steps': 'Approval Steps',
  'pages.oaWorkflows.field.stepNo': 'Step No.',
  'pages.oaWorkflows.field.stepName': 'Step Name',
  'pages.oaWorkflows.field.approverRole': 'Approver Role',
  'pages.oaWorkflows.step.stepNo': 'Step No.',
  'pages.oaWorkflows.step.stepName': 'Step Name',
  'pages.oaWorkflows.step.approverRole': 'Approver Role',
  'pages.oaWorkflows.validation.workflowName': 'Please enter a workflow name.',
  'pages.oaWorkflows.validation.stepNo': 'Please enter a step number.',
  'pages.oaWorkflows.validation.stepName': 'Please enter a step name.',
  'pages.oaWorkflows.validation.approverRole': 'Please select an approver role.',
  'pages.oaWorkflows.validation.noticeEmails': 'Please enter valid notification email addresses.',
  'pages.oaWorkflows.step.noticeEmails': 'Additional Notification Emails',
  'pages.oaWorkflows.step.noticeEmailsPlaceholder': 'Enter a notification email and press Enter',
  'pages.oaWorkflows.step.noticeEmailCount': 'Extra notice: {count}',
  'pages.oaWorkflows.action.addStep': 'Add Step',
  'pages.oaWorkflows.action.delete': 'Delete',
  'pages.oaWorkflows.action.deleteStep': 'Delete',
  'pages.oaWorkflows.msg.loadFailed': 'Failed to load leave workflows.',
  'pages.oaWorkflows.msg.updateSuccess': 'Leave workflow updated.',
  'pages.oaWorkflows.msg.updateFailed': 'Failed to update leave workflow.',

  // Common
  'pages.attendance.yes': 'はい',
  'pages.attendance.no': 'いいえ',
  'pages.attendance.accountId': 'Employee ID',
  'pages.attendance.employeeName': 'Employee Name',
  'pages.attendance.search.button': 'Search',
  'pages.attendance.search.placeholder':
    'Search by employee ID / account name / employee name / role / status',
  'pages.attendance.search.result': 'Search results',
  'pages.attendance.search.countUnit': 'items',
  'pages.accounting.salaryManagement.title': 'Salary Management',
  'pages.accounting.salaryManagement.search.button': 'Search',
  'pages.accounting.salaryManagement.search.placeholder':
    'Search by employee ID / employee name / account',
  'pages.accounting.salaryManagement.search.result': 'Search Results',
  'pages.accounting.salaryManagement.search.countUnit': 'items',
  'pages.accounting.salaryManagement.summary.companyActualIncome': 'Total Company Net Income',
  'pages.accounting.salaryManagement.summary.scope':
    'Total company net income based on employment in the selected month, including historical employment of currently resigned or disabled employees. Search and category filters do not affect the total. Unknown employment periods and settlements outside employment require review.',
  'pages.accounting.salaryManagement.summary.pendingHelp':
    'If any eligible employee cannot be calculated, show Review Required instead of a partial company total.',
  'pages.accounting.salaryManagement.summary.pendingCount': 'Employees Requiring Review',
  'pages.accounting.salaryManagement.reload': 'Reload',
  'pages.accounting.salaryManagement.filter.contractType': 'Contract Type',
  'pages.accounting.salaryManagement.filter.targetMonth': 'Target Month',
  'pages.accounting.salaryManagement.contractType.trainee': 'Employment-Oriented',
  'pages.accounting.salaryManagement.contractType.internal': 'Trainee (Offer Accepted)',
  'pages.accounting.salaryManagement.contractType.contract': 'Contract Employee',
  'pages.accounting.salaryManagement.contractType.employee': 'Contract / Regular Employees',
  'pages.accounting.salaryManagement.contractType.regular': 'Regular Employee',
  'pages.accounting.salaryManagement.contractType.bp': 'BP Employee',
  'pages.accounting.salaryManagement.contractType.resigned': 'Resigned',
  'pages.accounting.salaryManagement.accountStatus.active': 'Active',
  'pages.accounting.salaryManagement.accountStatus.disabled': 'Disabled',
  'pages.accounting.salaryManagement.status.active': 'Active',
  'pages.accounting.salaryManagement.status.undefined': 'Undefined',
  'pages.accounting.salaryManagement.status.contractFinished': 'Contract Ended',
  'pages.accounting.salaryManagement.status.bpFinished': 'BP Ended',
  'pages.accounting.salaryManagement.status.resigned': 'Resigned',
  'pages.accounting.salaryManagement.column.employeeId': 'Employee ID',
  'pages.accounting.salaryManagement.column.employeeName': 'Employee Name',
  'pages.accounting.salaryManagement.column.accountStatus': 'Account Status',
  'pages.accounting.salaryManagement.column.contractType': 'Contract Type',
  'pages.accounting.salaryManagement.column.status': 'Status',
  'pages.accounting.salaryManagement.column.currentSalary': 'Base Salary',
  'pages.accounting.salaryManagement.column.specialAllowance': 'Special Allowance',
  'pages.accounting.salaryManagement.column.employerBurden': 'Estimated Employer Cost',
  'pages.accounting.salaryManagement.column.totalCompanyCost': 'Total Company Cost',
  'pages.accounting.salaryManagement.column.projectRevenue': 'Project Revenue',
  'pages.accounting.salaryManagement.column.companyActualIncome': 'Company Actual Income',
  'pages.accounting.salaryManagement.projectRevenueHelp':
    'Selected-month forecast revenue before tax: invoice detail amounts when invoiced, otherwise project unit prices.',
  'pages.accounting.salaryManagement.companyActualIncomeHelp':
    'Company actual income = project revenue − total company cost.',
  'pages.accounting.salaryManagement.column.lastRaiseAmount': 'Latest Raise Amount',
  'pages.accounting.salaryManagement.column.lastRaiseDate': 'Latest Raise Date',
  'pages.accounting.salaryManagement.column.nextRaisePlannedDate': 'Next Planned Raise Date',
  'pages.accounting.salaryManagement.column.action': 'Actions',
  'pages.accounting.salaryManagement.modal.editTitle': 'Edit Salary Information',
  'pages.accounting.salaryManagement.modal.historyTitle': 'Raise History',
  'pages.accounting.salaryManagement.modal.historyTitleWithName': '{name} Raise History',
  'pages.accounting.salaryManagement.label.beforeSaveCurrentSalary': 'Base Salary Before Saving',
  'pages.accounting.salaryManagement.field.currentSalary': 'Base Salary',
  'pages.accounting.salaryManagement.field.specialAllowance': 'Special Allowance',
  'pages.accounting.salaryManagement.field.specialAllowance.extra':
    'A one-time allowance for {month}; included in employment insurance, workers compensation, and total company cost.',
  'pages.accounting.salaryManagement.insuranceSettings.title': 'Insurance Calculation Settings',
  'pages.accounting.salaryManagement.field.socialInsuranceApplicable': 'Social Insurance',
  'pages.accounting.salaryManagement.field.employmentInsuranceApplicable': 'Employment Insurance',
  'pages.accounting.salaryManagement.field.careInsuranceMode': 'Nursing Care Insurance',
  'pages.accounting.salaryManagement.option.applicable': 'Applicable',
  'pages.accounting.salaryManagement.option.notApplicable': 'Not Applicable',
  'pages.accounting.salaryManagement.option.careAuto': 'Automatic from Date of Birth',
  'pages.accounting.salaryManagement.option.careOn': 'Applicable',
  'pages.accounting.salaryManagement.option.careOff': 'Not Applicable',
  'pages.accounting.salaryManagement.field.healthStandardOverride':
    'Health Standard Monthly Remuneration (Override)',
  'pages.accounting.salaryManagement.field.pensionStandardOverride':
    'Pension Standard Monthly Remuneration (Override)',
  'pages.accounting.salaryManagement.field.standardOverride.extra':
    'Leave blank to derive the grade from base salary. Enter only when a notified standard remuneration is available.',
  'pages.accounting.salaryManagement.field.lastRaiseDate': 'Latest Raise Date',
  'pages.accounting.salaryManagement.field.lastRaiseAmount': 'Latest Raise Amount',
  'pages.accounting.salaryManagement.field.nextRaisePlannedDate': 'Next Planned Raise Date',
  'pages.accounting.salaryManagement.helper.syncHistory':
    'Saving the latest raise date and amount will also reflect the same content in the latest history record.',
  'pages.accounting.salaryManagement.history.column.raiseDate': 'Raise Date',
  'pages.accounting.salaryManagement.history.column.beforeCurrentSalary': 'Salary Before Raise',
  'pages.accounting.salaryManagement.history.column.afterCurrentSalary': 'Salary After Raise',
  'pages.accounting.salaryManagement.history.column.raiseAmount': 'Raise Amount',
  'pages.accounting.salaryManagement.history.column.nextRaisePlannedDate':
    'Next Planned Raise Date',
  'pages.accounting.salaryManagement.history.column.createdAt': 'Created At',
  'pages.accounting.salaryManagement.history.column.targetMonth': 'Target Month',
  'pages.accounting.salaryManagement.history.column.updatedAt': 'Updated At',
  'pages.accounting.salaryManagement.history.tab.salary': 'Raise History',
  'pages.accounting.salaryManagement.history.tab.specialAllowance': 'Special Allowance History',
  'pages.accounting.salaryManagement.history.empty': 'No history found.',
  'pages.accounting.salaryManagement.history.deleteConfirm':
    'Are you sure you want to delete this history record?',
  'pages.accounting.salaryManagement.action.edit': 'Edit',
  'pages.accounting.salaryManagement.action.history': 'History',
  'pages.accounting.salaryManagement.action.save': 'Save',
  'pages.accounting.salaryManagement.action.cancel': 'Cancel',
  'pages.accounting.salaryManagement.action.delete': 'Delete',
  'pages.accounting.salaryManagement.msg.loadFailed': 'Failed to load salary management data.',
  'pages.accounting.salaryManagement.msg.filterFailed': 'Failed to filter salary management data.',
  'pages.accounting.salaryManagement.msg.saveSuccess': 'Salary information saved.',
  'pages.accounting.salaryManagement.msg.saveFailed': 'Failed to save salary information.',
  'pages.accounting.salaryManagement.msg.historyLoadFailed': 'Failed to load raise history.',
  'pages.accounting.salaryManagement.msg.specialAllowanceHistoryLoadFailed':
    'Failed to load special allowance history.',
  'pages.accounting.salaryManagement.msg.historyDeleteSuccess': 'Raise history deleted.',
  'pages.accounting.salaryManagement.msg.historyDeleteFailed': 'Failed to delete raise history.',
  'pages.accounting.salaryManagement.guide.title':
    'Review base salary, monthly special allowances, and estimated employer costs in one place.',
  'pages.accounting.salaryManagement.guide.line1':
    'Select a target month, then use "Edit" to update base salary, special allowance, and insurance settings.',
  'pages.accounting.salaryManagement.guide.line2':
    'Saving the latest raise date and amount will also update the raise history. Incorrect history records can be deleted from "History".',
  'pages.accounting.salaryManagement.modal.guide.title':
    'Please confirm what you want to update before saving.',
  'pages.accounting.salaryManagement.modal.guide.line1':
    'If you only want to correct base salary, update only the base salary field and save.',
  'pages.accounting.salaryManagement.modal.guide.line2':
    'If you enter the latest raise date and amount, the same information will also be reflected in raise history.',
  'pages.accounting.salaryManagement.modal.guide.line3':
    'If a raise history entry was registered by mistake, it can be deleted later from the history dialog.',
  'pages.accounting.salaryManagement.field.currentSalary.extra':
    'Enter the employee’s current base salary. Use this field even when correcting data rather than registering a raise.',
  'pages.accounting.salaryManagement.field.lastRaiseDate.extra':
    'Enter this when you want to record the most recent raise date. It will be reflected in history.',
  'pages.accounting.salaryManagement.field.lastRaiseAmount.extra':
    'Enter the amount of the most recent raise. If saved together with the raise date, it will also be reflected in history.',
  'pages.accounting.salaryManagement.field.nextRaisePlannedDate.extra':
    'Enter this only when the next planned raise date has already been decided.',
  'pages.accounting.salaryManagement.history.guide.line1':
    'The newest history record is shown at the top. Incorrect records can be deleted.',
  'pages.accounting.salaryManagement.history.guide.line2':
    'After deleting a history record, the latest salary information in the list will also be recalculated from the remaining history.',
  'pages.accounting.salaryManagement.cost.outsideEmployment': 'Outside Employment Period',
  'pages.accounting.salaryManagement.cost.missingBaseSalary': 'Base Salary Missing',
  'pages.accounting.salaryManagement.cost.reviewRequired': 'Review Required',
  'pages.accounting.salaryManagement.cost.departureDateRequired': 'Departure Date Missing',
  'pages.accounting.salaryManagement.cost.departureDateRequiredHelp':
    'The disabled account has no departure date. Confirm employment and costs for this month; do not substitute zero or the fixed JPY 100,000 cost.',
  'pages.accounting.salaryManagement.cost.settlementReview': 'Settlement Review Required',
  'pages.accounting.salaryManagement.cost.settlementReviewHelp':
    'Project revenue or a special allowance exists outside the employment period. Review this monthly settlement; current salary and the fixed JPY 100,000 cost are not automatically applied.',
  'pages.accounting.salaryManagement.cost.rateNotConfigured': 'Rate Not Configured',
  'pages.accounting.salaryManagement.cost.breakdownTitle': 'Estimated Employer Cost Breakdown',
  'pages.accounting.salaryManagement.cost.healthStandard': 'Health Standard Monthly Remuneration',
  'pages.accounting.salaryManagement.cost.pensionStandard': 'Pension Standard Monthly Remuneration',
  'pages.accounting.salaryManagement.cost.health': 'Health Insurance',
  'pages.accounting.salaryManagement.cost.pension': 'Employees’ Pension',
  'pages.accounting.salaryManagement.cost.employment': 'Employment Insurance',
  'pages.accounting.salaryManagement.cost.workersComp': 'Workers’ Compensation',
  'pages.accounting.salaryManagement.cost.childRelated': 'Child-related Contributions',
  'pages.accounting.salaryManagement.cost.childRelatedDetail':
    'Support levy {support} / Childcare contribution {contribution}',
  'pages.accounting.salaryManagement.cost.care': 'Nursing Care Insurance',
  'pages.interviewList.filter.category': 'Interview Status',
  'pages.interviewList.filter.scheduled': 'Scheduled',
  'pages.interviewList.filter.pending': 'Pending',
  'pages.interviewList.filter.pass': 'Pass',
  'pages.interviewList.filter.fail': 'Fail',
  'pages.interviewList.column.sequenceNo': 'No.',
  'pages.interviewList.column.interviewScheduled': 'Interview Scheduled',
  'pages.interviewList.column.totalScore': 'Score',
  'pages.interviewList.column.interviewResult': 'Result',
  'pages.interviewList.column.attendanceStatus': 'Onboarding Status',
  'pages.interviewList.column.pic': 'PIC',
  'pages.interviewList.chart.title': 'Monthly Applications by Applied Date',
  'pages.interviewList.chart.subtitle': 'Reflects current search and filter conditions',
  'pages.interviewList.chart.month': 'Application Month',
  'pages.interviewList.chart.count': 'Count',
  'pages.interviewList.chart.countUnit': '',
  'pages.interviewList.chart.empty': 'No application-date data available.',
  'pages.interviewList.title': 'Interview List',
  'pages.interviewList.create': 'Create',
  'pages.interviewList.reload': 'Reload',
  'pages.interviewList.search.button': 'Search',
  'pages.interviewList.search.placeholder': 'Search by candidate, position, source, or PIC',
  'pages.interviewList.search.result': 'Results',
  'pages.interviewList.search.countUnit': ' items',
  'pages.interviewList.filter.all': 'All',
  'pages.interviewList.filter.applicationYear': 'Application Year',
  'pages.interviewList.filter.applicationMonth': 'Application Month',
  'pages.interviewList.filter.monthSuffix': 'M',
  'pages.interviewList.filter.status': 'Screening / Interview / Test Status',
  'pages.interviewList.filter.appliedPosition': 'Applied Position',
  'pages.interviewList.filter.sourceChannel': 'Application Source',
  'pages.interviewList.filter.position.it': 'IT',
  'pages.interviewList.filter.position.sales': 'Sales',
  'pages.interviewList.filter.position.office': 'Office',
  'pages.interviewList.filter.source.ijob': 'ijob',
  'pages.interviewList.filter.source.referral': 'Referral',
  'pages.interviewList.filter.source.xiaohongshu': 'Xiaohongshu',
  'pages.interviewList.filter.source.other': 'Other',
  'pages.interviewList.filter.status.screeningPass': 'Screening Pass',
  'pages.interviewList.filter.status.screeningFail': 'Screening Fail',
  'pages.interviewList.filter.status.screeningPending': 'Screening Pending',
  'pages.interviewList.filter.status.interviewScheduled': 'Interview Scheduled',
  'pages.interviewList.filter.status.firstPass': '1st Pass',
  'pages.interviewList.filter.status.firstFail': '1st Fail',
  'pages.interviewList.filter.status.firstPending': '1st Pending',
  'pages.interviewList.filter.status.testInProgress': 'Test In Progress',
  'pages.interviewList.filter.status.testPass': 'Test Pass',
  'pages.interviewList.filter.status.testFail': 'Test Fail',
  'pages.interviewList.column.listNo': 'No.',
  'pages.interviewList.column.candidateName': 'Candidate',
  'pages.interviewList.column.applicationDate': 'Applied On',
  'pages.interviewList.column.appliedPosition': 'Applied Position',
  'pages.interviewList.column.sourceChannel': 'Source',
  'pages.interviewList.column.screeningScore': 'Screening Score',
  'pages.interviewList.column.screeningResult': 'Screening Result',
  'pages.interviewList.column.interviewStatus': 'Interview Status',
  'pages.interviewList.column.interviewDate': 'Interview Date',
  'pages.interviewList.column.interviewForm': 'Interview Form',
  'pages.interviewList.column.firstInterviewScore': '1st Score',
  'pages.interviewList.column.firstInterviewResult': '1st Result',
  'pages.interviewList.column.action': 'Action',
  'pages.interviewList.modal.createTitle': 'Create Interview Record',
  'pages.interviewList.modal.editTitle': 'Edit Interview Record',
  'pages.interviewList.section.basic': 'Basic Information',
  'pages.interviewList.section.screening': 'Screening',
  'pages.interviewList.section.interview': 'Interview',
  'pages.interviewList.section.followup': 'Follow-up',
  'pages.interviewList.field.sequenceNo': 'Sequence No.',
  'pages.interviewList.field.applicationDate': 'Application Date',
  'pages.interviewList.field.candidateName': 'Candidate Name',
  'pages.interviewList.field.appliedPosition': 'Applied Position',
  'pages.interviewList.field.sourceChannel': 'Application Source',
  'pages.interviewList.field.pic': 'PIC',
  'pages.interviewList.field.skillMatchLevel': 'Skill Match',
  'pages.interviewList.field.experienceAssessment': 'Experience',
  'pages.interviewList.field.japaneseAssessment': 'Japanese Level',
  'pages.interviewList.field.visaType': 'Visa Type',
  'pages.interviewList.field.interviewScheduled': 'Interview Scheduled',
  'pages.interviewList.field.initialScreeningRemarks': 'Initial Screening Remarks',
  'pages.interviewList.field.attendanceStatus': 'Join Status',
  'pages.interviewList.field.interviewDate': 'Interview Date',
  'pages.interviewList.field.interviewForm': 'Interview Form',
  'pages.interviewList.field.skillEvaluation': 'Skill Evaluation',
  'pages.interviewList.field.motivationEvaluation': 'Motivation',
  'pages.interviewList.field.japaneseEvaluation': 'Japanese Evaluation',
  'pages.interviewList.field.attitudeEvaluation': 'Attitude',
  'pages.interviewList.field.totalScore': 'Total Score',
  'pages.interviewList.field.interviewResult': 'Interview Result',
  'pages.interviewList.field.interviewRemarks': 'Interview Remarks',
  'pages.interviewList.field.resultNotifyDate': 'Result Notify Date',
  'pages.interviewList.field.followupRemarks': 'Follow-up Remarks',
  'pages.interviewList.option.autoSequence': 'Assigned After Create',
  'pages.interviewList.option.unscheduled': 'Unscheduled',
  'pages.interviewList.option.scheduled': 'Scheduled',
  'pages.interviewList.option.online': 'Online',
  'pages.interviewList.option.offline': 'Offline',
  'pages.interviewList.option.pending': 'Pending',
  'pages.interviewList.option.pass': 'Pass',
  'pages.interviewList.option.fail': 'Fail',
  'pages.interviewList.action.edit': 'Edit',
  'pages.interviewList.action.delete': 'Delete',
  'pages.interviewList.action.save': 'Save',
  'pages.interviewList.action.cancel': 'Cancel',
  'pages.interviewList.confirm.delete': 'Delete this interview record?',
  'pages.interviewList.validation.candidateName': 'Please enter candidate name.',
  'pages.interviewList.msg.loadFailed': 'Failed to load interview records.',
  'pages.interviewList.msg.createSuccess': 'Interview record created.',
  'pages.interviewList.msg.updateSuccess': 'Interview record updated.',
  'pages.interviewList.msg.saveFailed': 'Failed to save interview record.',
  'pages.interviewList.msg.deleteSuccess': 'Interview record deleted.',
  'pages.interviewList.msg.deleteFailed': 'Failed to delete interview record.',
  'pages.interviewList.msg.rollbackToScreeningSuccess': 'Interview record returned to screening.',
  'pages.interviewList.msg.rollbackToScreeningFailed':
    'Failed to return interview record to screening.',

  'pages.interviewList.calendar.title': 'Interview Calendar',
  'pages.interviewList.calendar.firstInterview': '1st Interview',
  'pages.interviewList.calendar.testPeriod': 'Test Period',
  'pages.interviewList.calendar.noInterviews': 'No interviews scheduled',
  'pages.interviewList.calendar.noUpcoming': 'No upcoming schedule',
  'pages.interviewList.calendar.countUnit': '',
  'pages.interviewList.calendar.more': ' more',
  'pages.interviewList.calendar.upcoming': 'Upcoming',
  'pages.interviewList.calendar.button': 'Interview Calendar',
  // Account Management Page
  'pages.accountManagement.accountId': 'Account ID',
  'pages.accountManagement.email': 'Email',
  'pages.accountManagement.email.placeholder': 'Enter email address',
  'pages.accountManagement.emailInvalid': 'Please enter a valid email address.',
  'pages.accountManagement.emailIsVerified': 'Email Verification',
  'pages.accountManagement.phoneNumber': 'Phone Number',
  'pages.accountManagement.phoneNumber.placeholder': 'Example: 090-1234-5678',
  'pages.accountManagement.phoneNumberInvalid': 'Please enter a valid phone number.',
  'pages.accountManagement.phoneIsVerified': 'Phone Verification',
  'pages.accountManagement.operation': 'Actions',
  'pages.accountManagement.update': 'Edit',
  'pages.accountManagement.update.process': 'Updating account...',
  'pages.accountManagement.update.done': 'Account updated.',
  'pages.accountManagement.update.failed': 'Failed to update account.',
  'pages.accountManagement.accountName': 'Account Name',
  'pages.accountManagement.accountName.placeholder': 'Enter account name',
  'pages.accountManagement.account.required': 'Please enter account name.',
  'pages.accountManagement.account.accountNameLength': 'Account name must be 6 to 18 characters.',
  'pages.accountManagement.account.accountNameInvalid':
    'Account name must start with a letter and contain only half-width alphanumeric characters.',
  'pages.accountManagement.password': 'Password',
  'pages.accountManagement.password.placeholder': 'Enter password',
  'pages.accountManagement.password.required': 'Please enter password.',
  'pages.accountManagement.password.passwordLength': 'Password must be 6 to 18 characters.',
  'pages.accountManagement.password.passwordInvalid':
    'Password can contain only half-width alphanumeric characters.',
  'pages.accountManagement.passwordReset': 'Reset Password',
  'pages.accountManagement.passwordReset.process': 'Resetting password...',
  'pages.accountManagement.passwordReset.done': 'Password has been reset.',
  'pages.accountManagement.passwordReset.doneWithNotice':
    'Password has been reset to 123456. Please ask the user to change it.',
  'pages.accountManagement.passwordReset.failed': 'Failed to reset password.',
  'pages.accountManagement.passwordReset.confirmTitle': 'Reset this password?',
  'pages.accountManagement.passwordReset.confirmDescription':
    'The password will be reset to the default value 123456.',
  'pages.accountManagement.delete': 'Delete',
  'pages.accountManagement.delete.process': 'Deleting account...',
  'pages.accountManagement.delete.done': 'Account deleted.',
  'pages.accountManagement.delete.failed': 'Failed to delete account.',
  'pages.accountManagement.delete.confirmTitle': 'Delete this account?',
  'pages.accountManagement.delete.currentAccountDenied':
    'The current login account cannot be deleted.',
  'pages.accountManagement.delete.batchCurrentSkipped':
    'The current login account was excluded from deletion.',
  'pages.accountManagement.delete.batchConfirmTitle': 'Delete selected accounts?',
  'pages.accountManagement.delete.batchConfirmCount': 'Targets',
  'pages.accountManagement.delete.batchConfirmMore': 'More',
  'pages.accountManagement.searchList': 'Account List',
  'pages.accountManagement.serachList': 'Account List',
  'pages.accountManagement.create': 'Create Account',
  'pages.accountManagement.create.process': 'Creating account...',
  'pages.accountManagement.create.done': 'Account created.',
  'pages.accountManagement.create.failed': 'Failed to create account.',
  'pages.accountManagement.selected': 'Selected account(s)',
  'pages.accountManagement.selectedDelete': 'Delete selected accounts',
  'pages.accountManagement.roleSet': 'Edit Role',
  'pages.accountManagement.roleSet.view': 'Loading roles...',
  'pages.accountManagement.roleSet.title': 'Edit Account Roles',
  'pages.accountManagement.roleSet.roles': 'Select Roles',
  'pages.accountManagement.roleSet.selectedCount': 'Selected Roles',
  'pages.accountManagement.roleSet.empty': 'No roles are available.',
  'pages.accountManagement.roleSet.emptyConfirmTitle': 'Save without any roles?',
  'pages.accountManagement.roleSet.emptyConfirmContent':
    'Removing all roles may leave this account unable to access any pages.',
  'pages.accountManagement.roleSetting.process': 'Updating role information...',
  'pages.accountManagement.roleSetting.done': 'Role information updated.',
  'pages.accountManagement.roleSetting.failed': 'Failed to update role information.',
  'pages.accountManagement.verified': 'Verified',
  'pages.accountManagement.unverified': 'Unverified',
  'pages.accountManagement.countUnit': '',
  'pages.accountManagement.action.save': 'Save',
  'pages.accountManagement.action.cancel': 'Cancel',
  'pages.accountManagement.modal.createTitle': 'Create Account',
  'pages.accountManagement.modal.editTitle': 'Edit Account',
  'pages.accountManagement.modal.accountNameReadonly':
    'Account name cannot be changed after creation.',
  'pages.accountManagement.search.button': 'Search',
  'pages.accountManagement.search.placeholder':
    'Search by account ID / account name / email / phone',
  'pages.accountManagement.search.result': 'Search Results',
  'pages.accountManagement.reload': 'Reload',
  'pages.accountManagement.load.failed': 'Failed to load account list.',
  'pages.accountManagement.filter.status': 'Status',
  'pages.accountManagement.filter.all': 'All',
  'pages.accountManagement.filter.emailUnverified': 'Email Unverified',
  'pages.accountManagement.filter.phoneUnverified': 'Phone Unverified',
  'pages.accountManagement.accountStatus.title': 'Account Status',
  'pages.accountManagement.accountStatus.active': 'Active',
  'pages.accountManagement.accountStatus.disabled': 'Disabled',

  // Fixed asset management.
  'pages.fixedAssets.title': 'Fixed Assets',
  'pages.fixedAssets.countUnit': ' items',
  'pages.fixedAssets.group.sameName': 'Same-name assets',
  'pages.fixedAssets.group.assetCount': '{count} items',
  'pages.fixedAssets.group.mixed': 'Mixed',
  'pages.fixedAssets.group.expandForDetail': 'Expand to view',
  'pages.fixedAssets.group.expandForAction': 'Expand to act',
  'pages.fixedAssets.group.countSummary': '{groups} groups / {assets} items',
  'pages.fixedAssets.filter.all': 'All',
  'pages.fixedAssets.filter.category': 'Asset Category',
  'pages.fixedAssets.filter.status': 'Asset Status',
  'pages.fixedAssets.filter.location': 'Location',
  'pages.fixedAssets.filter.clear': 'Clear Filters',
  'pages.fixedAssets.search.placeholder': 'Search by asset name / asset number / brand / remarks',
  'pages.fixedAssets.search.button': 'Search',
  'pages.fixedAssets.action.create': 'New Asset',
  'pages.fixedAssets.action.edit': 'Edit',
  'pages.fixedAssets.action.copy': 'Copy',
  'pages.fixedAssets.action.delete': 'Delete',
  'pages.fixedAssets.action.save': 'Save',
  'pages.fixedAssets.action.bulkSave': 'Bulk Save',
  'pages.fixedAssets.action.copyAdd': 'Copy Add',
  'pages.fixedAssets.action.cancel': 'Cancel',
  'pages.fixedAssets.action.reload': 'Reload',
  'pages.fixedAssets.action.add': 'Add',
  'pages.fixedAssets.action.update': 'Update',
  'pages.fixedAssets.action.categoryManagement': 'Category Management',
  'pages.fixedAssets.action.addPart': 'Add Part',
  'pages.fixedAssets.action.addUsageHistory': 'Add Usage History',
  'pages.fixedAssets.column.assetNumber': 'Asset No.',
  'pages.fixedAssets.column.assetName': 'Asset Name',
  'pages.fixedAssets.column.category': 'Category',
  'pages.fixedAssets.column.brandOs': 'Brand / OS',
  'pages.fixedAssets.column.purchaseAmount': 'Purchase Amount',
  'pages.fixedAssets.column.purchaseDate': 'Purchase Date',
  'pages.fixedAssets.column.useDuration': 'Usage Duration',
  'pages.fixedAssets.column.location': 'Location',
  'pages.fixedAssets.column.currentUser': 'User',
  'pages.fixedAssets.column.stockInDate': 'Stock-in Date',
  'pages.fixedAssets.column.brand': 'Brand',
  'pages.fixedAssets.column.status': 'Status',
  'pages.fixedAssets.column.remarks': 'Remarks',
  'pages.fixedAssets.column.action': 'Action',
  'pages.fixedAssets.modal.createTitle': 'Create Fixed Asset',
  'pages.fixedAssets.modal.editTitle': 'Edit Fixed Asset',
  'pages.fixedAssets.modal.copyTitle': 'Copy Fixed Asset',
  'pages.fixedAssets.section.basic': 'Basic Information',
  'pages.fixedAssets.section.parts': 'Parts',
  'pages.fixedAssets.section.assetState': 'Asset State',
  'pages.fixedAssets.section.usageHistory': 'Usage History',
  'pages.fixedAssets.section.remarks': 'Remarks',
  'pages.fixedAssets.field.assetName': 'Asset Name',
  'pages.fixedAssets.field.majorCategory': 'Major Category',
  'pages.fixedAssets.field.subCategory': 'Subcategory',
  'pages.fixedAssets.field.brand': 'Brand',
  'pages.fixedAssets.field.purchaseAmount': 'Purchase Amount',
  'pages.fixedAssets.field.purchaseDate': 'Purchase Date',
  'pages.fixedAssets.field.location': 'Location',
  'pages.fixedAssets.field.assetStatus': 'Asset Status',
  'pages.fixedAssets.field.partName': 'Part Name',
  'pages.fixedAssets.field.quantity': 'Quantity',
  'pages.fixedAssets.field.registrationQuantity': 'Registration Quantity',
  'pages.fixedAssets.field.temporaryNumber': 'Temporary No.',
  'pages.fixedAssets.field.userName': 'User',
  'pages.fixedAssets.field.useStartDate': 'Start Date',
  'pages.fixedAssets.field.useEndDate': 'End Date',
  'pages.fixedAssets.field.stockInDate': 'Stock-in Date',
  'pages.fixedAssets.field.usePeriod': 'Usage Period',
  'pages.fixedAssets.placeholder.assetName': 'e.g. MacBook Pro 14-inch',
  'pages.fixedAssets.placeholder.majorCategory': 'Select major category',
  'pages.fixedAssets.placeholder.subCategory': 'Select subcategory',
  'pages.fixedAssets.placeholder.noSubCategory': 'No subcategory',
  'pages.fixedAssets.placeholder.brand': 'Apple / Dell / ELECOM, etc.',
  'pages.fixedAssets.placeholder.os': 'Windows 11 / macOS, etc.',
  'pages.fixedAssets.placeholder.location': 'Select location',
  'pages.fixedAssets.placeholder.status': 'Select status',
  'pages.fixedAssets.placeholder.partName': 'Part name',
  'pages.fixedAssets.placeholder.userName': 'Select an employee candidate, or enter directly',
  'pages.fixedAssets.placeholder.currentUser': 'Leave blank if currently in use',
  'pages.fixedAssets.placeholder.remarks':
    'Enter purchase amount, warranty period, management notes, etc.',
  'pages.fixedAssets.validation.assetNameRequired': 'Please enter the asset name.',
  'pages.fixedAssets.validation.majorCategoryRequired': 'Please select a major category.',
  'pages.fixedAssets.validation.purchaseAmountRequired': 'Please enter the purchase amount.',
  'pages.fixedAssets.validation.purchaseDateRequired': 'Please select the purchase date.',
  'pages.fixedAssets.validation.stockInDateRequired': 'Please select the stock-in date.',
  'pages.fixedAssets.validation.registrationQuantityRequired':
    'Please enter the registration quantity.',
  'pages.fixedAssets.validation.currentUserSingle': 'Please set only one current user.',
  'pages.fixedAssets.validation.locationRequired': 'Please select a location.',
  'pages.fixedAssets.confirm.deleteAsset': 'Delete this fixed asset?',
  'pages.fixedAssets.confirm.deleteCategory': 'Delete this category?',
  'pages.fixedAssets.message.loadFailed': 'Failed to load fixed asset information.',
  'pages.fixedAssets.message.detailLoadFailed': 'Failed to load fixed asset details.',
  'pages.fixedAssets.message.saved': 'Saved.',
  'pages.fixedAssets.message.saveFailed': 'Failed to save the fixed asset.',
  'pages.fixedAssets.message.deleted': 'Deleted.',
  'pages.fixedAssets.message.deleteFailed': 'Failed to delete the fixed asset.',
  'pages.fixedAssets.message.categorySaved': 'Category saved.',
  'pages.fixedAssets.message.categorySaveFailed': 'Failed to save the category.',
  'pages.fixedAssets.message.categoryDeleted': 'Category deleted.',
  'pages.fixedAssets.message.categoryDeleteFailed': 'Failed to delete the category.',
  'pages.fixedAssets.status.running': 'Running',
  'pages.fixedAssets.status.idle': 'Idle',
  'pages.fixedAssets.status.repairing': 'Repairing',
  'pages.fixedAssets.status.disposalPlanned': 'Disposal Planned',
  'pages.fixedAssets.status.disposed': 'Disposed',
  'pages.fixedAssets.location.warehouse': 'Warehouse',
  'pages.fixedAssets.location.development': 'Development',
  'pages.fixedAssets.location.ec': 'EC Department',
  'pages.fixedAssets.location.sales': 'Sales',
  'pages.fixedAssets.location.hr': 'Human Resources',
  'pages.fixedAssets.location.generalAffairs': 'General Affairs',
  'pages.fixedAssets.location.accounting': 'Accounting',
  'pages.fixedAssets.location.other': 'Other',
  'pages.fixedAssets.category.modalTitle': 'Fixed Asset Category Management',
  'pages.fixedAssets.category.addTitle': 'Add Category',
  'pages.fixedAssets.category.editTitle': 'Edit Category',
  'pages.fixedAssets.category.addMajorTitle': 'Add Major Category',
  'pages.fixedAssets.category.addSubTitle': 'Add Subcategory',
  'pages.fixedAssets.category.listTitle': 'Category List',
  'pages.fixedAssets.category.addMajorAction': 'Add Major Category',
  'pages.fixedAssets.category.addSubAction': 'Add Subcategory Under Selection',
  'pages.fixedAssets.category.empty': 'No categories yet.',
  'pages.fixedAssets.category.message.noParentCategory': 'Please add a major category first.',
  'pages.fixedAssets.category.column.name': 'Category Name',
  'pages.fixedAssets.category.column.sortOrder': 'Sort Order',
  'pages.fixedAssets.category.column.activeFlag': 'Status',
  'pages.fixedAssets.category.parentCategory': 'Parent Category',
  'pages.fixedAssets.category.parentPlaceholder': 'Leave empty for major categories',
  'pages.fixedAssets.category.parentSelectPlaceholder': 'Select parent category',
  'pages.fixedAssets.category.type': 'Category Type',
  'pages.fixedAssets.category.majorType': 'Add Major Category',
  'pages.fixedAssets.category.subType': 'Add Subcategory',
  'pages.fixedAssets.category.majorTypeHelp':
    'Add as a major category. A category code is required for asset numbering.',
  'pages.fixedAssets.category.subTypeHelp': 'Add a subcategory under the selected major category.',
  'pages.fixedAssets.category.name': 'Category Name',
  'pages.fixedAssets.category.code': 'Category Code',
  'pages.fixedAssets.category.codePlaceholder': 'e.g. IT',
  'pages.fixedAssets.category.sortOrder': 'Sort Order',
  'pages.fixedAssets.category.activeFlag': 'Active Status',
  'pages.fixedAssets.category.active': 'Active',
  'pages.fixedAssets.category.inactive': 'Inactive',
  'pages.fixedAssets.category.backToCreate': 'Back to New Entry',
  'pages.fixedAssets.category.validation.parentRequired': 'Please select a parent category.',
  'pages.fixedAssets.category.validation.nameRequired': 'Please enter the category name.',
  'pages.fixedAssets.category.validation.codeRequired': 'Please enter the category code.',
  'pages.fixedAssets.category.validation.codePattern':
    'Please enter 2 to 6 uppercase alphanumeric characters.',

  // Home gamification
  'pages.home.common.none': '-',
  'pages.home.common.pointSuffix': 'pt',
  'pages.home.common.minutesSuffix': 'min',
  'pages.home.notice.title': 'Internal Notices',
  'pages.home.notice.noUnread': 'No unread notices',
  'pages.home.notice.unreadCount': '{count} unread',
  'pages.home.notice.unread': 'Unread',
  'pages.home.notice.important': 'Important',
  'pages.home.notice.viewAll': 'View all',
  'pages.home.notice.noPublished': 'No published notices',
  'pages.home.notice.unreadModalTitle': 'Unread Notices',
  'pages.home.notice.noUnreadNotice': 'No unread notices',
  'pages.home.notice.publishDate': 'Published: {date}',
  'pages.home.growth.level': 'Level {level}',
  'pages.home.growth.experience': 'EXP {current}/{next}',
  'pages.home.growth.points': 'Points',
  'pages.home.growth.todayUsage': 'Today',
  'pages.home.growth.usagePoints': 'Usage Points',
  'pages.home.growth.gamePoints': 'Game Points',
  'pages.home.growth.exchangeHint':
    'Earn points through active use and games, then exchange them for titles and badges.',
  'pages.home.reward.type.title': 'Title',
  'pages.home.reward.type.badge': 'Badge',
  'pages.home.reward.type.icon': 'Icon',
  'pages.home.reward.type.frame': 'Frame',
  'pages.home.reward.type.reward': 'Reward',
  'pages.home.reward.descriptionLabel': 'Description:',
  'pages.home.reward.noEquippedBadgeDescription': 'No equipped badge description.',
  'pages.home.reward.titleNotSet': 'No title set',
  'pages.home.reward.badgeNotSet': 'No badge set',
  'pages.home.reward.exchangeSuccess': 'Reward exchanged.',
  'pages.home.reward.exchangeFailed': 'Failed to exchange reward.',
  'pages.home.reward.equipSuccess': 'Reward equipped.',
  'pages.home.reward.equipFailed': 'Failed to equip reward.',
  'pages.home.reward.exchangeButton': 'Exchange Points',
  'pages.home.reward.exchangeDrawerTitle': 'Exchange Points',
  'pages.home.reward.currentPoints': 'Current Points',
  'pages.home.reward.empty': 'No rewards available',
  'pages.home.reward.equipped': 'Equipped',
  'pages.home.reward.equip': 'Equip',
  'pages.home.reward.exchange': 'Exchange',
  'pages.home.game.selectionTitle': 'Game Selection',
  'pages.home.game.modalFallbackTitle': 'Game',
  'pages.home.game.raiden.title': 'Raiden Game',
  'pages.home.game.raiden.description': 'A quick shooting game to refresh your focus.',
  'pages.home.game.frogWords.title': 'Frog River Vocabulary Game',
  'pages.home.game.frogWords.description':
    'Type Japanese-Chinese IT terms and guide the frog across the river.',
  'pages.home.game.scoreGained': '{game} score submitted. You earned {points} points.',
  'pages.home.game.scoreRecorded': '{game} score recorded. No extra points today.',
  'pages.home.game.scoreSubmitFailed': 'Failed to submit {game} score.',
  'pages.home.game.leaderboardButton': 'Leaderboard',
  'pages.home.game.leaderboardTitle': '{game} Leaderboard',
  'pages.home.game.leaderboardFallbackTitle': 'Leaderboard',
  'pages.home.game.leaderboardScore': 'Total points: {points} / Best score: {bestScore}',
  'pages.home.game.leaderboardNoRank': 'Not on the board yet. Keep going.',
  'pages.home.game.leaderboardMyRank': 'Your current rank is {rank}. Total points: {points}',
  'pages.home.game.leaderboardEmpty': 'No leaderboard data yet.',
  'pages.home.game.leaderboardLoadFailed': 'Failed to load the leaderboard.',
  'pages.home.reward.gitApostle.name': 'Git Apostle',
  'pages.home.reward.gitApostle.description': 'A title for people familiar with Git workflow.',
  'pages.home.reward.testPaladin.name': 'Test Paladin',
  'pages.home.reward.testPaladin.description': 'A badge for guardians of test quality.',
  'pages.home.reward.raidenPilot.name': 'Raiden Pilot',
  'pages.home.reward.raidenPilot.description': 'An icon for people who challenge the Raiden game.',
  'pages.home.reward.blueFrame.name': 'Blue Frame',
  'pages.home.reward.blueFrame.description':
    'A frame that adds a small accent to your home profile.',
  'pages.home.reward.bugHunter.name': 'Bug Hunter',
  'pages.home.reward.bugHunter.description': 'A title for people who do not miss small defects.',
  'pages.home.reward.sqlSamurai.name': 'SQL Samurai',
  'pages.home.reward.sqlSamurai.description':
    'A title for those who quietly slice through joins and conditions.',
  'pages.home.reward.diffWizard.name': 'Diff Wizard',
  'pages.home.reward.diffWizard.description':
    'A title for reviewers who understand the intent behind diffs.',
  'pages.home.reward.morningSprinter.name': 'Morning Sprinter',
  'pages.home.reward.morningSprinter.description':
    'A title for people who move tasks forward lightly from the morning.',
  'pages.home.reward.midnightDeployGuardian.name': 'Midnight Deploy Guardian',
  'pages.home.reward.midnightDeployGuardian.description':
    'A title for those who watch over releases in the quiet night.',
  'pages.home.reward.specTraveler.name': 'Spec Traveler',
  'pages.home.reward.specTraveler.description':
    'A title for people who can walk through the forest of specifications.',
  'pages.home.reward.commitCraftsman.name': 'Commit Craftsman',
  'pages.home.reward.commitCraftsman.description':
    'A title for people who carefully stack each change.',
  'pages.home.reward.bugDetective.name': 'Bug Detective',
  'pages.home.reward.bugDetective.description':
    'A title for people who persist from symptoms to root cause.',
  'pages.home.reward.raidenAce.name': 'Raiden Ace',
  'pages.home.reward.raidenAce.description':
    'A title for people who fly through the sky in the Raiden game.',
  'pages.home.reward.raidenBulletApprentice.name': 'Bullet Curtain Trainee',
  'pages.home.reward.raidenBulletApprentice.description':
    'A title for pilots just beginning their bullet-hell baptism.',
  'pages.home.reward.raidenRookie.name': 'Raiden Rookie',
  'pages.home.reward.raidenRookie.description':
    'A title for people brave enough to press the launch button.',
  'pages.home.reward.skyDogfighter.name': 'Blue Sky Dogfighter',
  'pages.home.reward.skyDogfighter.description':
    'A title for people who weave through the blue sky with style.',
  'pages.home.reward.lowAltitudeDodger.name': 'Low-Altitude Dodger',
  'pages.home.reward.lowAltitudeDodger.description':
    'A title for pilots who somehow dodge everything near the ground.',
  'pages.home.reward.laserStraightShot.name': 'Straight-Line Laser',
  'pages.home.reward.laserStraightShot.description':
    'A title for people who fire straight ahead without hesitation.',
  'pages.home.reward.cloudSniper.name': 'Cloud Gap Sniper',
  'pages.home.reward.cloudSniper.description':
    'A title for people who aim precisely through gaps in the clouds.',
  'pages.home.reward.bossBreath.name': 'Pre-Boss Deep Breath',
  'pages.home.reward.bossBreath.description':
    'A title for people who remember to calm down before the boss fight.',
  'pages.home.reward.noDamagePrayer.name': 'No-Damage Prayer Trooper',
  'pages.home.reward.noDamagePrayer.description':
    'A title for people who charge in while praying for a no-damage run.',
  'pages.home.reward.thunderAce.name': 'Thunderclap Ace',
  'pages.home.reward.thunderAce.description':
    'A title for people who raise their score with the sound of thunder.',
  'pages.home.reward.airspaceCommander.name': 'Airspace Commander',
  'pages.home.reward.airspaceCommander.description':
    'A title for commanders who stay calm even when the screen is full.',
  'pages.home.reward.lilyPadJumper.name': 'Lily Pad Jumper',
  'pages.home.reward.lilyPadJumper.description':
    'A title for people who hop forward with the frog, pad by pad.',
  'pages.home.reward.wordHopper.name': 'Word Hopper',
  'pages.home.reward.wordHopper.description':
    'A title for people who answer the moment a word appears.',
  'pages.home.reward.jpCnWordFerryman.name': 'JP-CN Word Ferryman',
  'pages.home.reward.jpCnWordFerryman.description':
    'A title for people who build bridges between Japanese and Chinese.',
  'pages.home.reward.translationRiverGuide.name': 'Translation River Guide',
  'pages.home.reward.translationRiverGuide.description':
    'A title for people who guide others through the river of terms.',
  'pages.home.reward.lostParticleRescue.name': 'Lost Particle Rescue Team',
  'pages.home.reward.lostParticleRescue.description':
    'A title for people who gently rescue lost particles and endings.',
  'pages.home.reward.termFishingMaster.name': 'Term Fishing Master',
  'pages.home.reward.termFishingMaster.description':
    'A title for people who fish the right term out of memory.',
  'pages.home.reward.frogMemoryMaster.name': 'Frog Memory Master',
  'pages.home.reward.frogMemoryMaster.description':
    'A title for people who memorize words faster than the frog can jump.',
  'pages.home.reward.bilingualSkipKing.name': 'Bilingual Skip King',
  'pages.home.reward.bilingualSkipKing.description':
    'A title for people who skip lightly between two languages.',
  'pages.home.reward.wrongAnswerRecovery.name': 'Wrong Answer Recovery Crew',
  'pages.home.reward.wrongAnswerRecovery.description':
    'A title for people who recover quickly and take the next step.',
  'pages.home.reward.oppositeBankSage.name': 'Opposite Bank Sage',
  'pages.home.reward.oppositeBankSage.description':
    'A title for people who connect words all the way to the final lily pad.',
  'pages.home.reward.quietImprover.name': 'Quiet Improver',
  'pages.home.reward.quietImprover.description':
    'A title for people who steadily make improvements that are easy to miss.',
  'pages.home.reward.qualityGuardianBadge.name': 'Quality Guardian Badge',
  'pages.home.reward.qualityGuardianBadge.description': 'A badge that shows respect for quality.',
  'pages.home.reward.learningFinisherMedal.name': 'Learning Finisher Medal',
  'pages.home.reward.learningFinisherMedal.description':
    'A badge honoring the strength to finish learning.',
  'pages.home.reward.monthEndAttendanceMaster.name': 'Month-End Attendance Master',
  'pages.home.reward.monthEndAttendanceMaster.description':
    'A badge for people who never forget month-end attendance tasks.',
  'pages.home.reward.blueLightning.name': 'Blue Lightning',
  'pages.home.reward.blueLightning.description':
    'An icon that gives your home profile a sharper look.',
  'pages.home.reward.coffeeRefueler.name': 'Coffee Refueler',
  'pages.home.reward.coffeeRefueler.description':
    'An icon you may want beside you during focus time.',
  'pages.home.reward.keyboardNinja.name': 'Keyboard Ninja',
  'pages.home.reward.keyboardNinja.description': 'An icon for people who enjoy fast typing.',
  'pages.home.reward.sakuraFrame.name': 'Sakura Frame',
  'pages.home.reward.sakuraFrame.description': 'A profile frame with a soft impression.',
  'pages.home.reward.nightShiftFrame.name': 'Night Shift Frame',
  'pages.home.reward.nightShiftFrame.description': 'A frame inspired by focused work at night.',
  'pages.home.reward.goldLine.name': 'Gold Line',
  'pages.home.reward.goldLine.description': 'A gold-style frame with a subtle special feel.',
  'pages.hrDocument.title': 'Document Requests',
  'pages.hrDocument.management.title': 'Document Request Management',
  'pages.hrDocument.management.listTitle': 'Request Management List',
  'pages.hrDocument.list.title': 'Request List',
  'pages.hrDocument.detail.title': 'Document Request Details',
  'pages.hrDocument.status.0': 'Draft',
  'pages.hrDocument.status.1': 'Pending Approval',
  'pages.hrDocument.status.2': 'Returned',
  'pages.hrDocument.status.3': 'Preparing',
  'pages.hrDocument.status.4': 'Awaiting receipt',
  'pages.hrDocument.status.5': 'Completed',
  'pages.hrDocument.status.6': 'Canceled',
  'pages.hrDocument.delivery.download': 'System Download',
  'pages.hrDocument.delivery.pickup': 'Counter Pickup',
  'pages.hrDocument.field.requestNo': 'Request No.',
  'pages.hrDocument.field.status': 'Status',
  'pages.hrDocument.field.applicant': 'Applicant',
  'pages.hrDocument.field.department': 'Department',
  'pages.hrDocument.field.documentType': 'Document Type',
  'pages.hrDocument.field.quantity': 'Copies',
  'pages.hrDocument.field.reason': 'Purpose / Reason',
  'pages.hrDocument.field.destination': 'Submission Destination',
  'pages.hrDocument.field.desiredDate': 'Desired Delivery Date',
  'pages.hrDocument.field.deliveryMethod': 'Delivery Method',
  'pages.hrDocument.field.notes': 'Additional Notes',
  'pages.hrDocument.field.returnReason': 'Return Reason',
  'pages.hrDocument.field.cancelReason': 'Cancellation Reason',
  'pages.hrDocument.field.actions': 'Actions',
  'pages.hrDocument.action.create': 'New Request',
  'pages.hrDocument.action.edit': 'Edit',
  'pages.hrDocument.action.detail': 'Details',
  'pages.hrDocument.action.submit': 'Submit',
  'pages.hrDocument.action.cancel': 'Cancel',
  'pages.hrDocument.action.delete': 'Delete',
  'pages.hrDocument.action.download': 'Download',
  'pages.hrDocument.action.approve': 'Approve',
  'pages.hrDocument.action.return': 'Return',
  'pages.hrDocument.action.ready': 'Mark Ready',
  'pages.hrDocument.action.complete': 'Complete Delivery',
  'pages.hrDocument.action.upload': 'Upload PDF',
  'pages.hrDocument.action.confirm': 'Confirm',
  'pages.hrDocument.action.back': 'Back',
  'pages.hrDocument.confirm.submit': 'Submit this request?',
  'pages.hrDocument.confirm.cancel': 'Cancel this request?',
  'pages.hrDocument.confirm.delete': 'Permanently delete this request?',
  'pages.hrDocument.confirm.approve': 'Approve this request?',
  'pages.hrDocument.confirm.ready': 'Mark this document as ready for delivery?',
  'pages.hrDocument.confirm.complete': 'Complete delivery of this document?',
  'pages.hrDocument.confirm.deleteFile': 'Delete this PDF?',
  'pages.hrDocument.confirm.deleteType': 'Delete this document type?',
  'pages.hrDocument.filter.status': 'Status',
  'pages.hrDocument.filter.all': 'All',
  'pages.hrDocument.filter.keyword': 'Search by request no., type, or reason',
  'pages.hrDocument.filter.managementKeyword': 'Search by request no., employee, or reason',
  'pages.hrDocument.form.createTitle': 'Create Document Request',
  'pages.hrDocument.form.editTitle': 'Edit Document Request',
  'pages.hrDocument.files.title': 'Delivery Files',
  'pages.hrDocument.files.empty': 'No delivery files',
  'pages.hrDocument.history.title': 'Processing History',
  'pages.hrDocument.return.title': 'Return Document Request',
  'pages.hrDocument.cancel.title': 'Cancel Document Request',
  'pages.hrDocument.type.manage': 'Document Type Management',
  'pages.hrDocument.type.create': 'Add Document Type',
  'pages.hrDocument.type.edit': 'Edit Document Type',
  'pages.hrDocument.type.code': 'Type Code',
  'pages.hrDocument.type.name': 'Type Name',
  'pages.hrDocument.type.description': 'Description',
  'pages.hrDocument.type.order': 'Display Order',
  'pages.hrDocument.type.active': 'Active Status',
  'pages.hrDocument.type.enabled': 'Active',
  'pages.hrDocument.type.disabled': 'Inactive',
  'pages.hrDocument.msg.loadFailed': 'Failed to load document requests.',
  'pages.hrDocument.msg.detailFailed': 'Failed to load request details.',
  'pages.hrDocument.msg.actionFailed': 'The operation failed.',
  'pages.hrDocument.msg.downloadFailed': 'Failed to download the file.',
  'pages.hrDocument.msg.saveSuccess': 'Document request saved.',
  'pages.hrDocument.msg.saveFailed': 'Failed to save.',
  'pages.hrDocument.msg.submitSuccess': 'Document request submitted.',
  'pages.hrDocument.msg.cancelSuccess': 'Document request canceled.',
  'pages.hrDocument.msg.deleteSuccess': 'Document request deleted.',
  'pages.hrDocument.msg.approveSuccess': 'Document request approved.',
  'pages.hrDocument.msg.returnSuccess': 'Document request returned.',
  'pages.hrDocument.msg.readySuccess': 'Document is ready for delivery.',
  'pages.hrDocument.msg.completeSuccess': 'Document delivery completed.',
  'pages.hrDocument.msg.uploadSuccess': 'PDF uploaded.',
  'pages.hrDocument.msg.uploadFailed': 'Failed to upload the PDF.',
  'pages.hrDocument.msg.fileDeleteSuccess': 'PDF deleted.',
  'pages.hrDocument.msg.typeSaveSuccess': 'Document type saved.',
  'pages.hrDocument.msg.typeDeleteSuccess': 'Document type deleted.',
  'pages.hrDocument.action.save': 'Save',
  'pages.hrDocument.action.register': 'Register',
  'pages.hrDocument.action.preview': 'Preview PDF',
  'pages.hrDocument.action.generate': 'Generate PDF',
  'pages.hrDocument.action.generateDeliver': 'Generate and deliver',
  'pages.hrDocument.action.redeliver': 'Redeliver',
  'pages.hrDocument.confirm.redeliver': 'Redeliver this document with a new 7-day download window?',
  'pages.hrDocument.confirm.deleteStamp': 'Permanently delete this electronic stamp?',
  'pages.hrDocument.type.deliveryMethods': 'Available delivery methods',
  'pages.hrDocument.type.allowDownload': 'Online download',
  'pages.hrDocument.type.allowPickup': 'Counter pickup',
  'pages.hrDocument.template.edit': 'Template',
  'pages.hrDocument.template.title': '{type} template',
  'pages.hrDocument.template.name': 'Template name',
  'pages.hrDocument.template.variables': 'Automatic variables (click to insert)',
  'pages.hrDocument.template.body': 'Template body',
  'pages.hrDocument.template.customFields': 'Additional generation fields',
  'pages.hrDocument.template.fieldLabel': 'Field label',
  'pages.hrDocument.template.required': 'Required',
  'pages.hrDocument.template.addField': 'Add input field',
  'pages.hrDocument.stamp.manage': 'Electronic stamps',
  'pages.hrDocument.stamp.name': 'Stamp name',
  'pages.hrDocument.stamp.fileName': 'Registered file',
  'pages.hrDocument.stamp.selectPng': 'Select PNG',
  'pages.hrDocument.generate.title': 'Generate document PDF',
  'pages.hrDocument.generate.stamp': 'Electronic stamp',
  'pages.hrDocument.generate.noStamp': 'No stamp',
  'pages.hrDocument.download.notice':
    'You can download repeatedly for 7 days after delivery. Contact HR for redelivery after the deadline.',
  'pages.hrDocument.download.expired':
    'The download deadline has passed. Contact HR for redelivery.',
  'pages.hrDocument.download.expiresAt': 'Download deadline',
  'pages.hrDocument.download.expiredShort': 'Expired',
  'pages.hrDocument.download.countdown': '{days}d {hours}h remaining',
  'pages.hrDocument.msg.templateLoadFailed': 'Failed to load the template.',
  'pages.hrDocument.msg.templateSaveSuccess': 'Template saved.',
  'pages.hrDocument.msg.templateSaveFailed': 'Failed to save the template.',
  'pages.hrDocument.msg.stampLoadFailed': 'Failed to load electronic stamps.',
  'pages.hrDocument.msg.stampSaveFailed': 'Failed to register the electronic stamp.',
  'pages.hrDocument.msg.generateLoadFailed': 'Failed to load PDF generation data.',
  'pages.hrDocument.msg.previewFailed': 'Failed to generate the PDF preview.',
  'pages.hrDocument.msg.generateSuccess': 'PDF generated and delivered.',
  'pages.hrDocument.msg.generateFailed': 'Failed to generate or deliver the PDF.',
  'pages.hrDocument.msg.redeliverSuccess': 'Document redelivered.',
  'pages.invoiceList.taxCategory': 'Tax category',
  'pages.invoiceList.taxCategory.taxable': 'Taxable',
  'pages.invoiceList.taxCategory.nonTaxable': 'Non-taxable',
  'pages.invoiceList.amount.subtotal': 'Subtotal',
  'pages.invoiceList.amount.taxableSubtotal': 'Taxable amount',
  'pages.invoiceList.amount.nonTaxableSubtotal': 'Non-taxable amount',
  'pages.invoiceList.amount.tax': 'Consumption tax 10%',
  'pages.invoiceList.amount.total': 'Total amount',
  'pages.invoiceList.attendance.totalHours': 'Monthly worked hours',
  'pages.invoiceList.attendance.status': 'Attendance status',
  'pages.invoiceList.attendance.status.unsubmitted': 'Not submitted',
  'pages.invoiceList.attendance.status.pending': 'Pending approval',
  'pages.invoiceList.attendance.status.approved': 'Approved',
  'pages.invoiceList.attendance.export': 'Attendance export',
  'pages.invoiceList.attendance.export.excel': 'Export Excel',
  'pages.invoiceList.attendance.export.pdf': 'Export PDF',
  'pages.invoiceList.attendance.export.noTargets': 'There are no attendance records to export.',
  'pages.accounting.dashboard.title': 'Accounting Dashboard',
  'pages.accounting.dashboard.subtitle':
    'Estimated profit after deducting personnel costs for contract and regular employees from invoice revenue.',
  'pages.accounting.dashboard.monthSuffix': '',
  'pages.accounting.dashboard.mode.forecast': 'Forecast',
  'pages.accounting.dashboard.tax.excluded': 'Excl. tax',
  'pages.accounting.dashboard.tax.included': 'Incl. tax',
  'pages.accounting.dashboard.metric.revenue': 'Invoice revenue',
  'pages.accounting.dashboard.metric.personnelCost': 'Total personnel cost',
  'pages.accounting.dashboard.metric.profit': 'Estimated profit after personnel cost',
  'pages.accounting.dashboard.section.monthly': 'Month {month}',
  'pages.accounting.dashboard.section.annual': '{year} total',
  'pages.accounting.dashboard.note.selectedMonth': 'Selected month',
  'pages.accounting.dashboard.note.salaryFormula':
    'Base salary + special allowance + employer burden',
  'pages.accounting.dashboard.note.annual': 'January through December',
  'pages.accounting.dashboard.note.margin': 'Margin {margin}',
  'pages.accounting.dashboard.table.title': '12-month details',
  'pages.accounting.dashboard.table.month': 'Month',
  'pages.accounting.dashboard.table.baseSalary': 'Base salary',
  'pages.accounting.dashboard.table.specialAllowance': 'Special allowance',
  'pages.accounting.dashboard.table.employerBurden': 'Estimated employer burden',
  'pages.accounting.dashboard.table.margin': 'Margin',
  'pages.accounting.dashboard.table.warningCount': 'Review count',
  'pages.accounting.dashboard.status.review': 'Review required',
  'pages.accounting.dashboard.warning.title': 'Some months require calculation review',
  'pages.accounting.dashboard.warning.description':
    'Missing salary, birthday, rates or departure dates, and settlements outside employment, require cost and profit review. Currently disabled accounts still count in their historical employment months.',
  'pages.accounting.dashboard.message.loadFailed': 'Failed to load the accounting dashboard.',
  'pages.attendanceInput.submitConfirm.title': 'Confirm attendance submission ({year}-{month})',
  'pages.attendanceInput.submitConfirm.message':
    'Complete all attendance information for the month before submitting, and check for missing entries.',
  'pages.attendanceInput.submitConfirm.editLock': 'You cannot edit attendance after submission.',
  'pages.attendanceInput.submitConfirm.ok': 'Confirm and submit',
  'pages.attendanceInput.submitConfirm.cancel': 'Go back and check',
  'pages.development.learnManagement.progress.evaluation.title': 'Evaluation',
  'pages.development.learnManagement.progress.evaluation.empty': 'Not entered',
  'pages.development.learnManagement.progress.evaluation.edit': 'Edit evaluation',
  'pages.development.learnManagement.progress.evaluation.save': 'Save',
  'pages.development.learnManagement.progress.evaluation.cancel': 'Cancel',
  'pages.development.learnManagement.progress.evaluation.placeholder':
    'Enter an evaluation (up to 100 characters)',
  'pages.development.learnManagement.progress.evaluation.saved': 'Evaluation saved.',
  'pages.development.learnManagement.progress.evaluation.saveFailed':
    'Could not save the evaluation. Check your input and try again.',
  'pages.development.learnManagement.progress.evaluation.tooLong':
    'Evaluations must be 100 characters or fewer. Existing content will not be truncated automatically.',
};
